import { GeneratedBuildData } from 'web/data/models'

export const GENERATED_MAIN: GeneratedBuildData = JSON.parse(`{
    "changelog": [
      "- All of TWW"
    ],
    "modifiersById": {
      "97cecb8f-4f90-4c43-8a0e-d18e8a424303": {
        "eligibleSpecIds": [
          "0c9d68bc-e126-4a07-817a-72c37094e005",
          "2fed59fd-6bdc-4b4e-a7d6-70c70cf8a5aa",
          "34b5a797-05ef-4431-91a0-64cc76a97624"
        ],
        "game_id": 53271,
        "icon_name": "ability_hunter_masterscall",
        "id": "97cecb8f-4f90-4c43-8a0e-d18e8a424303",
        "meta": "",
        "name": "Master's Call",
        "shortName": "Call"
      }
    },
    "patchInfo": {
      "buildVersion": "1100_1"
    },
    "specsById": {
      "08853913-0c47-4ca1-aec0-e93206a6ee45": {
        "classId": "122a0a6d-d523-4cc2-a743-f3d42d3e7f02",
        "icon_name": "ability_demonhunter_specdps",
        "id": "08853913-0c47-4ca1-aec0-e93206a6ee45",
        "name": "Havoc",
        "role": "Melee DPS",
        "shortName": "Havoc",
        "spellIds": [
          "cf47dd1b-57ce-4ff0-90c1-0066a187718b"
        ],
        "talentIds": [
          "8c99b3d5-62d2-4672-bbec-50eb0f3c8fc2",
          "fe615593-20ff-4088-a323-e7087544216e"
        ]
      },
      "0c9d68bc-e126-4a07-817a-72c37094e005": {
        "classId": "0a3fc2d5-66d5-42da-abc4-2bfbcf5bc9b3",
        "icon_name": "ability_hunter_camouflage",
        "id": "0c9d68bc-e126-4a07-817a-72c37094e005",
        "name": "Survival",
        "role": "Melee DPS",
        "shortName": "Surv",
        "spellIds": [
          "7917bfe4-1e09-4e4a-94ff-4afeb3745797",
          "a945fd6b-ec7b-42b4-8025-7671b2c79e6c"
        ],
        "talentIds": [
          "a5d22dfd-d455-47b6-9c74-9e6820822273"
        ]
      },
      "18dad85c-ac2c-4aac-b0f8-e0fc4b8633e6": {
        "classId": "9223f4e8-8669-451e-815a-d53a19416c5a",
        "icon_name": "spell_monk_brewmaster_spec",
        "id": "18dad85c-ac2c-4aac-b0f8-e0fc4b8633e6",
        "name": "Brewmaster",
        "role": "Tank",
        "shortName": "BRM",
        "spellIds": [
          "8aec93d2-2aff-49ec-adc7-7c7dacd98380",
          "c21f4b62-777b-408f-81ed-98ef91a62fb8"
        ],
        "talentIds": [
          "13db282d-b721-475d-aa6e-bd131791db66",
          "d83b8700-8bfa-4601-aa8a-9afc6bf9e019"
        ]
      },
      "1b478900-c50e-49f6-b9b1-d2fedfb10c2b": {
        "classId": "532f16f1-1e8b-4aba-af5d-17b292fc05fd",
        "icon_name": "spell_deathknight_unholypresence",
        "id": "1b478900-c50e-49f6-b9b1-d2fedfb10c2b",
        "name": "Unholy",
        "role": "Melee DPS",
        "shortName": "Unholy",
        "spellIds": [
          "149105e0-feb0-4535-bfc6-27239ada49ce",
          "36e3f2a2-2ab9-4115-9a36-9a66c5a8ebd5"
        ],
        "talentIds": [
          "36b1b8cd-86d9-43fd-92b7-ac5b1198cd07",
          "cc962c25-6a3b-4af0-b286-da67b821f3e7"
        ]
      },
      "1df0b300-a31e-4ebc-be57-a909f82bab4b": {
        "classId": "d599cd61-11ae-4a4d-a856-60d1c7f4572d",
        "icon_name": "spell_nature_lightning",
        "id": "1df0b300-a31e-4ebc-be57-a909f82bab4b",
        "name": "Elemental",
        "role": "Ranged DPS",
        "shortName": "Ele",
        "spellIds": [
          "9002f891-b356-4f67-9c0f-f7e512ddb5ef",
          "a5a8d118-41b4-4bfc-81c9-61453aec3832",
          "b73387fc-91ff-40f9-9fdf-0d855927d16e"
        ],
        "talentIds": [
          "37b9b1a4-c4e5-4290-be71-3eeab3bcf617",
          "6414c5fb-36ad-430f-ae2b-edaa0a58bf31",
          "88aed695-3e44-4edc-9399-a9f0017c4acc",
          "8e1ffa2c-8997-4646-b1d1-b2f6483955c7",
          "adb2c731-a09c-4c5a-a5cb-787fe6c5d768",
          "e49ee804-2e24-47ea-9004-5af8b327b73f"
        ]
      },
      "1fcfbc91-0ad8-4c1d-ab1a-ff9424abc17d": {
        "classId": "0a450e25-065c-4c3c-a881-cea74cf08462",
        "icon_name": "ability_warrior_innerrage",
        "id": "1fcfbc91-0ad8-4c1d-ab1a-ff9424abc17d",
        "name": "Fury",
        "role": "Melee DPS",
        "shortName": "Fury",
        "spellIds": [
          "7f8a2f91-f4c5-44f0-b88f-8069484976e1"
        ],
        "talentIds": []
      },
      "2fed59fd-6bdc-4b4e-a7d6-70c70cf8a5aa": {
        "classId": "0a3fc2d5-66d5-42da-abc4-2bfbcf5bc9b3",
        "icon_name": "ability_hunter_bestialdiscipline",
        "id": "2fed59fd-6bdc-4b4e-a7d6-70c70cf8a5aa",
        "name": "Beast Mastery",
        "role": "Ranged DPS",
        "shortName": "BM",
        "spellIds": [
          "09704b27-46b4-4a33-a5b5-bc0f60360b0b",
          "c71b94d6-8470-436b-afd8-1aee1981099d"
        ],
        "talentIds": [
          "48461dc1-c85b-470c-ba5a-269b701ebe18"
        ]
      },
      "34735ecf-bf9e-4225-bb6e-ee617b024b70": {
        "classId": "532f16f1-1e8b-4aba-af5d-17b292fc05fd",
        "icon_name": "spell_deathknight_bloodpresence",
        "id": "34735ecf-bf9e-4225-bb6e-ee617b024b70",
        "name": "Blood",
        "role": "Tank",
        "shortName": "Blood",
        "spellIds": [
          "a351975d-4d53-440a-8fe5-13836f8e86e4",
          "ea074334-e633-46bd-9958-3fdb463068fd",
          "ef6d59d7-7522-4b4c-9111-9f554edd4614"
        ],
        "talentIds": [
          "2b36a255-0d1f-4edb-ac7d-2f9cca13bfa3",
          "467b7328-32ae-44e2-8532-3f958a7badb8",
          "5859b929-053b-4ddb-b0d7-e14bf3f43d4b",
          "6798d5c7-eef8-4965-913b-3c60d97760f7"
        ]
      },
      "34b5a797-05ef-4431-91a0-64cc76a97624": {
        "classId": "0a3fc2d5-66d5-42da-abc4-2bfbcf5bc9b3",
        "icon_name": "ability_hunter_focusedaim",
        "id": "34b5a797-05ef-4431-91a0-64cc76a97624",
        "name": "Marksman",
        "role": "Ranged DPS",
        "shortName": "Mark",
        "spellIds": [
          "38094d11-eef8-4047-ae8e-b8e513ee7da8",
          "5ed0a91e-1880-4f9a-b644-4c13470a61e5"
        ],
        "talentIds": [
          "e9389c2c-4ab3-49eb-93db-030b2a7f4f38"
        ]
      },
      "3f5cbe75-0a0e-4406-90a7-d46833c9fca2": {
        "classId": "5b6efded-e5dd-4429-adfd-2c6d3893e678",
        "icon_name": "ability_rogue_waylay",
        "id": "3f5cbe75-0a0e-4406-90a7-d46833c9fca2",
        "name": "Outlaw",
        "role": "Melee DPS",
        "shortName": "Outlaw",
        "spellIds": [],
        "talentIds": []
      },
      "48a205f0-5e24-4382-9e0b-3c06cfc1b873": {
        "classId": "fabd40be-24a8-4b80-8445-416b6e77e15f",
        "icon_name": "classicon_evoker_preservation",
        "id": "48a205f0-5e24-4382-9e0b-3c06cfc1b873",
        "name": "Preservation",
        "role": "Healer",
        "shortName": "Pres",
        "spellIds": [
          "0b91fae5-c221-4816-8ae6-995b2ee34a04",
          "16979d3b-3831-4d0b-8266-af4f5847ef58",
          "6322bfa2-4658-493d-ac8d-4dce32f0d793",
          "87749372-54d2-419f-916d-7799b8d3f40d",
          "a82b3af9-5f7f-4848-8a8c-9085a1e66a49",
          "c29a1e24-cdf1-4a90-8f66-0f710de6b95f",
          "d322ee3a-ae53-442b-a1cf-664f2d61d04b",
          "f5ef4208-c8b1-4ac0-9e72-2d5fd1588b69"
        ],
        "talentIds": [
          "0d992c62-362c-4dfc-924b-047f67be2ca8",
          "4765648f-fc35-4305-bdce-e4353eec9c2c",
          "53f260ec-ac2b-4cb4-91b0-1b252665ee23",
          "ab58d1d9-db4d-4e7a-a014-86eaa08c1611",
          "cbf60eb9-cf97-4773-9ac7-0d7604dedaf0",
          "e9ed1039-2542-45a5-9a7e-0da17313acfa",
          "ecc35489-c4e9-4f68-8901-74620e18cdc4",
          "fae8f28c-27b6-4cf9-8ed3-cb1bb3701924"
        ]
      },
      "48c27d79-2cc2-4674-bfd0-9a471f6c7ced": {
        "classId": "f3899285-de29-4692-a640-98b5d03579ee",
        "icon_name": "spell_shadow_shadowwordpain",
        "id": "48c27d79-2cc2-4674-bfd0-9a471f6c7ced",
        "name": "Shadow",
        "role": "Ranged DPS",
        "shortName": "Shadow",
        "spellIds": [
          "7aeb468b-c67a-44ce-a38e-f7ce21d5abad",
          "91dc9c20-57a2-4220-92b8-6395b97d6bd5",
          "99b1990f-4cce-4f10-8a2d-4a7c2f8b449b"
        ],
        "talentIds": [
          "5d8b76f1-d88a-4f9c-a3b5-27aae8a8077f",
          "6135360a-e47e-4124-bbda-82ca19adf51e",
          "a9b0335f-6b6c-4acd-8ebb-e00ff27061f3",
          "ca124356-8a91-4702-8f65-d5f36efb7f74",
          "e85a95e3-89cf-4a0a-8ecd-498d67ce906d"
        ]
      },
      "4ac0a1e4-3352-49e9-b455-faa83312526d": {
        "classId": "d056557a-1414-4958-b859-11656dfc0528",
        "icon_name": "spell_holy_auraoflight",
        "id": "4ac0a1e4-3352-49e9-b455-faa83312526d",
        "name": "Retribution",
        "role": "Melee DPS",
        "shortName": "Ret",
        "spellIds": [
          "12af0606-3665-4be2-9d2b-1d2776f7e827",
          "38e8bdc2-7193-4359-b3bb-5ef89e6df63f",
          "a328e53b-28a9-4fa5-87e7-e71eeb7b2b5b",
          "aec2b540-401c-4d38-a747-b6416e11b018"
        ],
        "talentIds": [
          "534403c0-3c0d-45b3-9ef1-e3783fa41c08",
          "785ffa5a-ad28-4cdc-8d55-d1035e67b2fc",
          "bb6eed55-913d-4289-b32a-6affe9882b83",
          "f9902ec9-b2b7-4b8a-95d7-f9a11d14eb73",
          "fa1c4c3c-2365-4bc9-9b94-80f64b91ff0c"
        ]
      },
      "51daa0f0-df16-4983-ae44-e11b5f9b3edb": {
        "classId": "d599cd61-11ae-4a4d-a856-60d1c7f4572d",
        "icon_name": "spell_nature_magicimmunity",
        "id": "51daa0f0-df16-4983-ae44-e11b5f9b3edb",
        "name": "Restoration",
        "role": "Healer",
        "shortName": "Resto",
        "spellIds": [
          "006e6534-a284-4b73-9edf-8e5b7d016036",
          "491d48b9-059d-4d04-904f-2df4b4ef31eb",
          "4dcb852c-13d1-4f98-b290-6b7448e12c83",
          "9bd01167-e150-4923-9a59-227797e713d0",
          "9cdb8790-b5a3-4d6e-9be8-f0146844df8c",
          "c749dc6b-7e45-4a5c-beb5-67ebe7e908ab",
          "d8bcbe43-916e-4bae-aa75-b5d43a3c55cc",
          "e927283d-2e30-47d0-a11c-d29bc0da0ffd"
        ],
        "talentIds": [
          "08b1232f-f4ea-4669-b3e1-62e89668784e",
          "0fc53a13-f373-47e8-bd6e-55f9a5e6bb09",
          "246b8dc0-68dc-447e-bed9-27137dbcf377",
          "446f9fbe-49ec-44ae-b856-c8631d8ef5b8",
          "5593c3e0-7e79-4351-9453-9b56a6a39293",
          "7b46fd01-71ff-4529-b389-36572f789c27",
          "ae467e33-fb17-47ab-8fc2-d548b0f3f715",
          "c473579c-60b9-4a98-bd6e-75073994f1f3",
          "c895b503-d882-4b28-857e-82dd60f2767d",
          "d1218a0b-f1c3-4c76-a222-b93cb9a5fd04",
          "d8d6839a-17e6-4932-b0f1-0219b61a03f9"
        ]
      },
      "575905ae-cdc7-44c8-946c-861d50111b6d": {
        "classId": "3667f06e-ab4c-4b9d-8fd0-c6640ad86486",
        "icon_name": "ability_druid_catform",
        "id": "575905ae-cdc7-44c8-946c-861d50111b6d",
        "name": "Feral",
        "role": "Melee DPS",
        "shortName": "Feral",
        "spellIds": [
          "2108e3a6-f8f7-47f1-948b-eef23d7c3899",
          "2631857d-abdc-4f01-9639-48815ab13616",
          "98043a6f-447a-4d3e-8eb6-44368e5ba2bd",
          "b8cb697b-d456-4489-9d61-d0a286129d55"
        ],
        "talentIds": [
          "07e2d1df-0a38-4075-adfc-998eb7def218",
          "45b5c689-fc1e-40a1-bf50-e41365e7456c",
          "583dcc89-53be-49c8-a9ac-2a8da54f5ed7",
          "82799079-fa85-4f5e-879c-e65b685a5783"
        ]
      },
      "67a45712-192e-4916-ad57-d9a13124fea6": {
        "classId": "f3899285-de29-4692-a640-98b5d03579ee",
        "icon_name": "spell_holy_powerwordshield",
        "id": "67a45712-192e-4916-ad57-d9a13124fea6",
        "name": "Discipline",
        "role": "Healer",
        "shortName": "Disc",
        "spellIds": [
          "04e8fdc0-0c2d-4ea5-980a-7ad7c34786e5",
          "08498d00-d197-4fad-bf1a-29e6fb2caec2",
          "16b54a37-4c8a-4a9e-974c-63ec64724a6d",
          "266fff1a-966f-42de-830e-b7edbedcfa86",
          "4ca718b9-1e94-4b2d-8988-18fbb6b3bfdc",
          "688d3cff-a59f-4bc8-8c67-84a616649881",
          "98a8efbd-f141-4487-9505-180b0ffb067f",
          "b9c5c635-ebd2-407e-a9c4-143df8566bce",
          "d3e989d5-5153-45d5-a442-8fa2c926661c",
          "ed7bf7a5-d61b-4276-9182-c8ee0cad090e"
        ],
        "talentIds": [
          "10f830ed-9048-4865-97fb-ffc816f65f66",
          "26fec4ad-7893-4450-a0d4-c0a2352b1f4d",
          "59502386-a715-4059-9eba-bf5539df99ac",
          "6e25b87c-bc9a-446a-97f3-26c82d84bb2c",
          "c2b8f54e-bc64-4f3f-bc20-342458ce8b34",
          "c32b2053-7d2d-4c02-a7cc-6325e09b4b68"
        ]
      },
      "6c233e8c-5bd4-4ece-9fb8-529a1e78759b": {
        "classId": "3667f06e-ab4c-4b9d-8fd0-c6640ad86486",
        "icon_name": "spell_nature_starfall",
        "id": "6c233e8c-5bd4-4ece-9fb8-529a1e78759b",
        "name": "Balance",
        "role": "Ranged DPS",
        "shortName": "Balance",
        "spellIds": [
          "63e24cd3-74af-4050-a6c1-091a4854ed98",
          "6a8f3c04-6fc2-4757-8a68-84d59c7b3e46",
          "a18258ed-6fbd-4a5b-928f-5664f54ba566",
          "f5761e2f-fb64-4165-afb2-7be13df8da66"
        ],
        "talentIds": [
          "4d782bee-99f7-4568-9fad-84058719b8a3",
          "81b03fbd-2ac3-49d1-b0d7-0d8aaa97371c",
          "90c7b081-5aa9-413d-a638-42961d68a966",
          "a04511c0-e7e5-4877-b694-d2dffa11a5b2"
        ]
      },
      "72947601-4270-4e1e-b917-25aacaa6d3e0": {
        "classId": "3667f06e-ab4c-4b9d-8fd0-c6640ad86486",
        "icon_name": "spell_nature_healingtouch",
        "id": "72947601-4270-4e1e-b917-25aacaa6d3e0",
        "name": "Restoration",
        "role": "Healer",
        "shortName": "Resto",
        "spellIds": [
          "2e788ebd-4f2f-4a77-8cad-fd108af4a159",
          "5171e67e-edba-4ca5-a90a-20216088e900",
          "546b181c-e440-4a39-a5d6-a7760a09526f",
          "864c11d9-76e9-46bc-8d57-83a78694d5c3",
          "ebb778df-bef7-4ffa-8820-195aed3e8f40",
          "f1731241-a892-464e-8b03-ca55f727e65a"
        ],
        "talentIds": [
          "15c1f077-0c6c-4a3a-a75a-02bff29b5664",
          "3c45d7a2-9e52-4017-9f18-3014ffe0e430",
          "4f846cbc-f718-43ad-ab0a-812ca4467f23",
          "5ea2d30f-6c4c-49b9-85d5-0d6995adc68c",
          "b3ec93a1-6250-452a-ab54-e85e52924163",
          "c98d366c-eae5-42a5-92e8-1288aa88eb0c",
          "d48a7d3f-16f6-4e44-bed2-fee66d8ea35a"
        ]
      },
      "7f8d7fab-f5cc-4d47-9212-565bab25aeed": {
        "classId": "843ce836-b215-488f-b73b-d08e3904ddca",
        "icon_name": "spell_fire_firebolt02",
        "id": "7f8d7fab-f5cc-4d47-9212-565bab25aeed",
        "name": "Fire",
        "role": "Ranged DPS",
        "shortName": "Fire",
        "spellIds": [
          "9c6ad09a-828e-4c60-a9a2-c3d2f244d941"
        ],
        "talentIds": [
          "85050e0d-9137-4795-a826-d43e83b648bd"
        ]
      },
      "83b7651d-c296-4a15-9932-b4012144b6ec": {
        "classId": "0a450e25-065c-4c3c-a881-cea74cf08462",
        "icon_name": "ability_warrior_defensivestance",
        "id": "83b7651d-c296-4a15-9932-b4012144b6ec",
        "name": "Protection",
        "role": "Tank",
        "shortName": "Prot",
        "spellIds": [
          "755896e9-8f8d-4262-b481-78b35619c227"
        ],
        "talentIds": []
      },
      "88f4a6b5-7766-41c3-b824-fbba531a2c8e": {
        "classId": "9223f4e8-8669-451e-815a-d53a19416c5a",
        "icon_name": "spell_monk_windwalker_spec",
        "id": "88f4a6b5-7766-41c3-b824-fbba531a2c8e",
        "name": "Windwalker",
        "role": "Melee DPS",
        "shortName": "WW",
        "spellIds": [
          "2dfdca50-d43e-4051-9889-86a0af8e4d11",
          "ab6f223c-68a1-479e-b033-e41f6fc8ea49"
        ],
        "talentIds": [
          "a17bab75-7676-4f19-99b2-d83ef3d0ba47",
          "b79c8b55-8181-4eba-a8f3-d5da08cb994f",
          "dc690ae9-da03-4789-ba73-6a34a9c9f4b0"
        ]
      },
      "8fceebcc-a93b-4692-81ea-331b2e59d43d": {
        "classId": "d056557a-1414-4958-b859-11656dfc0528",
        "icon_name": "ability_paladin_shieldofthetemplar",
        "id": "8fceebcc-a93b-4692-81ea-331b2e59d43d",
        "name": "Protection",
        "role": "Tank",
        "shortName": "Prot",
        "spellIds": [
          "56d42104-e78f-46d5-9f56-a7e2bc8ca6ca",
          "5d50199c-9064-4adb-8d76-3e2651510e31",
          "7ec6fd94-a652-4491-a1b7-32a977ab331e",
          "cb1a07db-73ca-46da-abac-e8a5bbb4a6ad",
          "fb72136a-1814-46eb-bf51-4dc08461274d"
        ],
        "talentIds": [
          "0de55575-ade5-426f-b47c-584e507ac416",
          "1576891d-9e1e-40ff-9df1-a49e099472a2",
          "3238af4a-e6bf-44a7-befe-0b3bb7a3d95d",
          "39bd329d-50e1-4e76-976c-360dedc08150",
          "acd54740-8f4f-4ef4-bf1a-7fc26d12b74b",
          "c3e6af3d-81c1-440e-8f07-5c058b6500e9",
          "d740f1d1-23b0-4047-8ba1-d81aad23336b",
          "e6d6e422-df70-4eca-a4f7-be3c357887a2"
        ]
      },
      "a022f6ed-2b4e-4ddf-a7e9-7fb746f5adc2": {
        "classId": "843ce836-b215-488f-b73b-d08e3904ddca",
        "icon_name": "spell_frost_frostbolt02",
        "id": "a022f6ed-2b4e-4ddf-a7e9-7fb746f5adc2",
        "name": "Frost",
        "role": "Ranged DPS",
        "shortName": "Frost",
        "spellIds": [
          "6e002afb-b81e-45ff-acbb-049081b3d052"
        ],
        "talentIds": [
          "e4ef9154-7c60-4f82-b7f4-aee7e072bea1"
        ]
      },
      "ab48ab5c-dfb9-4ce9-9557-8d0ce5129df2": {
        "classId": "843ce836-b215-488f-b73b-d08e3904ddca",
        "icon_name": "spell_holy_magicalsentry",
        "id": "ab48ab5c-dfb9-4ce9-9557-8d0ce5129df2",
        "name": "Arcane",
        "role": "Ranged DPS",
        "shortName": "Arcane",
        "spellIds": [
          "31fdaf76-04ec-434d-a817-c022448c3678",
          "6583c72c-4b79-4435-bae9-fcc1b5c32d17",
          "905c4d07-80a8-4d0c-97d5-d29c0bde98ba",
          "cab7cdd0-1733-4f2b-9e3c-2f9dacb84cc8"
        ],
        "talentIds": [
          "40039152-7e24-4b87-9693-459badf45081",
          "496f5f29-c065-4cfc-9cad-c7c31f51c188",
          "94332795-35fc-4c49-bba0-18c103bb408e",
          "b13f131b-222d-481c-93cb-fe4ac8e4ab9e"
        ]
      },
      "af2ca3dc-34c9-4632-98d2-6ea12a2a72f9": {
        "classId": "d599cd61-11ae-4a4d-a856-60d1c7f4572d",
        "icon_name": "spell_shaman_improvedstormstrike",
        "id": "af2ca3dc-34c9-4632-98d2-6ea12a2a72f9",
        "name": "Enhancement",
        "role": "Melee DPS",
        "shortName": "Enh",
        "spellIds": [
          "30f48251-6f5b-4d6b-b2be-c04274a1e1f2",
          "bc7f3a24-3640-4403-8e1d-5f327c0db931",
          "c359b7b7-a981-4c4b-bb80-7bf57e1be922"
        ],
        "talentIds": [
          "176aea1a-5c86-40b5-bf15-f978497cdc97",
          "20670122-e9f4-464e-ab04-5c758107c629",
          "758b104b-e4db-4437-a728-06c0791981d6",
          "8a529137-da4a-4974-96e5-7beb6bb028d6",
          "b2448fed-b273-4d91-897b-749bd8c26c12",
          "dfd7b903-eab9-4010-ab5d-2e09abd07fd6"
        ]
      },
      "b72fb4f9-413a-4222-8569-b3cb8e5e67f2": {
        "classId": "532f16f1-1e8b-4aba-af5d-17b292fc05fd",
        "icon_name": "spell_deathknight_frostpresence",
        "id": "b72fb4f9-413a-4222-8569-b3cb8e5e67f2",
        "name": "Frost",
        "role": "Melee DPS",
        "shortName": "Frost",
        "spellIds": [
          "3b16750b-c297-4cc0-9ded-5151749bc1fe",
          "88024cd3-bfc6-42c5-a1b5-a277b51407d8"
        ],
        "talentIds": [
          "32687d7b-f4b4-45a5-a1d0-d64037b764e3",
          "767e54f0-88e8-417f-9d8a-e487ca01fc6a"
        ]
      },
      "bcaf8201-dac9-48b9-b329-f2d73d7e8a8b": {
        "classId": "1d680db4-2a3f-4805-800d-00ea34d98880",
        "icon_name": "spell_shadow_metamorphosis",
        "id": "bcaf8201-dac9-48b9-b329-f2d73d7e8a8b",
        "name": "Demonology",
        "role": "Ranged DPS",
        "shortName": "Demo",
        "spellIds": [],
        "talentIds": []
      },
      "be905ae2-ec32-49bf-bc82-ef1cbf83ce9f": {
        "classId": "3667f06e-ab4c-4b9d-8fd0-c6640ad86486",
        "icon_name": "ability_racial_bearform",
        "id": "be905ae2-ec32-49bf-bc82-ef1cbf83ce9f",
        "name": "Guardian",
        "role": "Tank",
        "shortName": "Guard",
        "spellIds": [
          "03897498-b6bc-478e-bcb4-3da8f178ae43",
          "7d7162a5-7e78-4957-973d-1b226afd667c",
          "83f198c3-72fe-45a3-8a71-23e848414d30",
          "e27a01f2-41c4-4f8f-ab6f-7b3e95a5d5a6"
        ],
        "talentIds": [
          "24a1ecf6-a951-4652-bd26-2d6b12a3262b",
          "37a85b35-ee30-4f8a-aad5-679ba20ee2eb",
          "7351775e-92b7-478f-a030-104aaf1d6adc",
          "c63562ef-5188-4a55-aefe-6ae707d4fc9d"
        ]
      },
      "c719a5bb-cbad-4e7b-841e-bbc7f28f6865": {
        "classId": "1d680db4-2a3f-4805-800d-00ea34d98880",
        "icon_name": "spell_shadow_rainoffire",
        "id": "c719a5bb-cbad-4e7b-841e-bbc7f28f6865",
        "name": "Destruction",
        "role": "Ranged DPS",
        "shortName": "Destro",
        "spellIds": [],
        "talentIds": []
      },
      "c95c2375-57fa-4ae8-9d55-c2e939b82247": {
        "classId": "122a0a6d-d523-4cc2-a743-f3d42d3e7f02",
        "icon_name": "ability_demonhunter_spectank",
        "id": "c95c2375-57fa-4ae8-9d55-c2e939b82247",
        "name": "Vengeance",
        "role": "Tank",
        "shortName": "Veng",
        "spellIds": [
          "dcf29b11-b583-4da1-8e7b-eb072d5003d3"
        ],
        "talentIds": [
          "a22a383c-ff9b-48d4-b532-1d1941d71774",
          "bbd1c3c3-96df-45f1-8c59-dea4fee0d9ca"
        ]
      },
      "cbfc9a1d-a504-4c56-8887-681e57a87211": {
        "classId": "fabd40be-24a8-4b80-8445-416b6e77e15f",
        "icon_name": "classicon_evoker_devastation",
        "id": "cbfc9a1d-a504-4c56-8887-681e57a87211",
        "name": "Devastation",
        "role": "Ranged DPS",
        "shortName": "Deva",
        "spellIds": [
          "06c8b627-79ac-4f1f-8229-fa69ec922b20",
          "baf7f1e4-f326-4ff2-9dfb-42d0f05f120e",
          "cd92e6a0-814a-46f9-b63b-c3e41f965dd8",
          "e7f75540-166c-4cbb-a69d-3589acd7691e"
        ],
        "talentIds": [
          "9a9316a3-8f95-4cb4-9587-8745777e125f",
          "ba35bc19-6a14-4fe9-99a9-5f86a1d2ba69",
          "cff1e89d-61b7-475f-8be5-f1b8e0e9badf",
          "db645c3d-704e-43b1-97ef-c6c0f2119c8d"
        ]
      },
      "d122a0b5-d857-4bc5-a456-c7250f8f6690": {
        "classId": "f3899285-de29-4692-a640-98b5d03579ee",
        "icon_name": "spell_holy_guardianspirit",
        "id": "d122a0b5-d857-4bc5-a456-c7250f8f6690",
        "name": "Holy",
        "role": "Healer",
        "shortName": "Holy",
        "spellIds": [
          "1ace0b3c-c69b-4078-8dca-e1972e7e12b2",
          "8350ad72-337c-4c95-844c-18eea40a8c8b",
          "a779de5c-f483-4fa1-aa40-43581326f792",
          "c79698a5-28cd-4797-88a8-e7d83df40d45",
          "ca1bd677-a9dd-4850-ac8f-5557466b2da3",
          "cb951cc4-f66a-401e-a3fc-2d8088ca2407",
          "cfb7415b-728a-43b6-a2f1-fb829c149c8c",
          "dbabf9cc-7f51-4727-8b44-c0cb6a1a4342"
        ],
        "talentIds": [
          "02d314aa-f05d-414b-8f82-15893e8b198f",
          "06ef5380-b89d-40ca-b37b-2b32edc3bf29",
          "128f953d-cfef-4cdf-9a9d-72da96c01bde",
          "145705e0-34fa-408a-9c4c-0eb095164bd8",
          "270c2610-9e02-4240-8eb2-4cb9c551fbe3",
          "8a23386b-bec3-4c9c-8b91-6f0978cbd9e8",
          "dcc4d8cc-cd6e-4b5d-8ce1-d22b0695212a",
          "ec19073f-a8e0-4d9f-b011-66a417942590"
        ]
      },
      "da2dc773-9412-4b11-ab2b-7d06e200b9d3": {
        "classId": "9223f4e8-8669-451e-815a-d53a19416c5a",
        "icon_name": "spell_monk_mistweaver_spec",
        "id": "da2dc773-9412-4b11-ab2b-7d06e200b9d3",
        "name": "Mistweaver",
        "role": "Healer",
        "shortName": "MW",
        "spellIds": [
          "12de984d-13e9-416d-aa95-de2194c07251",
          "1933d67f-b51a-4749-a6dc-012a6be0726b",
          "76430eb8-165c-4f9f-a619-4ee302197f32",
          "7ceb50d9-f44b-4ff8-bf75-5a432b340c0d",
          "e1d00dfa-fff5-424c-adef-7da054dc3897",
          "e791e627-d68b-4dcc-9e37-ce471e86b268"
        ],
        "talentIds": [
          "160dfe8a-fd9e-4a9f-b3b7-844269786fc4",
          "1f8e2d40-918d-4603-a15c-59423e2585d7",
          "5268ec1f-cde9-4148-ad41-bb67a35df24c",
          "7ff235d6-9752-4d3f-a7b5-87d1df11b114",
          "909f1f5b-a757-443d-b336-cd86f48d1dfd",
          "d3753af3-0a20-46d8-bd73-0702c8f1826f",
          "fdf0f7fc-8feb-462c-a253-2711e3406cce"
        ]
      },
      "e1af3b62-ddf5-4369-a528-dab8ab94d366": {
        "classId": "d056557a-1414-4958-b859-11656dfc0528",
        "icon_name": "spell_holy_holybolt",
        "id": "e1af3b62-ddf5-4369-a528-dab8ab94d366",
        "name": "Holy",
        "role": "Healer",
        "shortName": "Holy",
        "spellIds": [
          "05e0b6a4-18d0-4820-8c8e-cbb379cb8634",
          "2bce4547-fce7-4d62-b894-2018ef2589ef",
          "2d0bf39e-ccef-44b9-b8a2-c6ccf254fbc9",
          "58faeff0-a646-4a51-a1fa-5edf41381f34",
          "781ef5af-1d36-4492-bc2f-43ec32d57e34",
          "bf98a80a-a8a5-4d0e-bc27-1e71fbacb7f9",
          "c4104b9d-26b6-4cd2-8dc9-f346f94346c5",
          "ca893cdb-27d4-4fdc-8534-4f61461ce940",
          "e4fc858c-8c0d-4dd3-a155-c970a14dba92"
        ],
        "talentIds": [
          "03d12b2f-f177-4460-9e0e-04238063e477",
          "1bb6cb6a-b5f4-42b0-bb16-93795ebac03e",
          "2588c632-df3c-4ac7-97c9-b3b2af36df74",
          "266e2fbc-b0a8-44e3-8332-40ad6b7310f2",
          "816a3a32-a4d2-4cfb-aad8-47c749c6222f",
          "bb927fdc-86d0-4d3c-868b-962396fb9b96",
          "d5a857c6-ac57-4c82-b898-c998614e61bd",
          "d8f9ecd6-716b-4389-9d7e-99a1b43a6af9",
          "e5ef6ddf-9621-484c-86ab-e02943b2145e",
          "faa69883-c426-46d8-b4c5-78959be4f168"
        ]
      },
      "e6b1de69-ce2c-467c-ae7a-e1613ba23fb9": {
        "classId": "fabd40be-24a8-4b80-8445-416b6e77e15f",
        "icon_name": "classicon_evoker_augmentation",
        "id": "e6b1de69-ce2c-467c-ae7a-e1613ba23fb9",
        "name": "Augmentation",
        "role": "Ranged DPS",
        "shortName": "Aug",
        "spellIds": [
          "13a13f04-2165-4dcc-8c30-e478e805ebb6",
          "226e9a3c-34a1-4cc6-a4c4-40192975733d",
          "359100cf-3a6a-4ea5-b2b3-5863e4c0da04",
          "fe0aa554-2490-4bdc-b674-0eec49b04bc4"
        ],
        "talentIds": [
          "29d23e3f-53ed-4fa9-a788-39af5ac8cc21",
          "73034b1a-bd86-4d63-986d-00767150da9d",
          "a30e6676-997f-4a3a-bb78-d353d6ab618d",
          "aa664140-7871-414a-ac39-5b19c0f56efc"
        ]
      },
      "e92b34bc-aa34-4579-a543-2ece2545d981": {
        "classId": "0a450e25-065c-4c3c-a881-cea74cf08462",
        "icon_name": "ability_warrior_savageblow",
        "id": "e92b34bc-aa34-4579-a543-2ece2545d981",
        "name": "Arms",
        "role": "Melee DPS",
        "shortName": "Arms",
        "spellIds": [
          "aa903e1f-9c6c-46b2-a3a1-1040686a4433"
        ],
        "talentIds": []
      },
      "f7e76d65-219d-47f1-be05-d7464de52a14": {
        "classId": "1d680db4-2a3f-4805-800d-00ea34d98880",
        "icon_name": "spell_shadow_deathcoil",
        "id": "f7e76d65-219d-47f1-be05-d7464de52a14",
        "name": "Affliction",
        "role": "Ranged DPS",
        "shortName": "Affli",
        "spellIds": [],
        "talentIds": []
      },
      "f950baa2-0deb-4250-a225-5232b1e74c2c": {
        "classId": "5b6efded-e5dd-4429-adfd-2c6d3893e678",
        "icon_name": "ability_stealth",
        "id": "f950baa2-0deb-4250-a225-5232b1e74c2c",
        "name": "Subtlety",
        "role": "Melee DPS",
        "shortName": "Sub",
        "spellIds": [],
        "talentIds": []
      },
      "fc46ed9d-3914-469f-a71f-6e4495efcf27": {
        "classId": "5b6efded-e5dd-4429-adfd-2c6d3893e678",
        "icon_name": "ability_rogue_deadlybrew",
        "id": "fc46ed9d-3914-469f-a71f-6e4495efcf27",
        "name": "Assassination",
        "role": "Melee DPS",
        "shortName": "Assa",
        "spellIds": [],
        "talentIds": []
      }
    },
    "spellsById": {
      "006e6534-a284-4b73-9edf-8e5b7d016036": {
        "affectedByModifierIds": [],
        "cooldown": 180,
        "game_id": 98008,
        "icon_name": "spell_shaman_spiritlink",
        "id": "006e6534-a284-4b73-9edf-8e5b7d016036",
        "name": "Spirit Link Totem",
        "shortName": "SLT"
      },
      "03897498-b6bc-478e-bcb4-3da8f178ae43": {
        "affectedByModifierIds": [],
        "cooldown": 120,
        "game_id": 106898,
        "icon_name": "spell_druid_stampedingroar_cat",
        "id": "03897498-b6bc-478e-bcb4-3da8f178ae43",
        "name": "Stampeding Roar",
        "shortName": "Roar"
      },
      "04e8fdc0-0c2d-4ea5-980a-7ad7c34786e5": {
        "affectedByModifierIds": [],
        "cooldown": 240,
        "game_id": 421453,
        "icon_name": "ability_priest_ascendance",
        "id": "04e8fdc0-0c2d-4ea5-980a-7ad7c34786e5",
        "name": "Ultimate Penitence",
        "shortName": "Penti",
        "talentId": "6e25b87c-bc9a-446a-97f3-26c82d84bb2c"
      },
      "05e0b6a4-18d0-4820-8c8e-cbb379cb8634": {
        "affectedByModifierIds": [],
        "cooldown": 180,
        "game_id": 31821,
        "icon_name": "spell_holy_auramastery",
        "id": "05e0b6a4-18d0-4820-8c8e-cbb379cb8634",
        "name": "Aura Mastery",
        "shortName": "AM"
      },
      "06c8b627-79ac-4f1f-8229-fa69ec922b20": {
        "affectedByModifierIds": [],
        "cooldown": 60,
        "game_id": 370665,
        "icon_name": "ability_evoker_flywithme",
        "id": "06c8b627-79ac-4f1f-8229-fa69ec922b20",
        "name": "Rescue",
        "shortName": "Resc",
        "talentId": "db645c3d-704e-43b1-97ef-c6c0f2119c8d"
      },
      "08498d00-d197-4fad-bf1a-29e6fb2caec2": {
        "affectedByModifierIds": [],
        "cooldown": 90,
        "game_id": 73325,
        "icon_name": "priest_spell_leapoffaith_a",
        "id": "08498d00-d197-4fad-bf1a-29e6fb2caec2",
        "name": "Leap of Faith",
        "shortName": "Leap",
        "talentId": "10f830ed-9048-4865-97fb-ffc816f65f66"
      },
      "09704b27-46b4-4a33-a5b5-bc0f60360b0b": {
        "affectedByModifierIds": [],
        "cooldown": 45,
        "game_id": 53271,
        "icon_name": "ability_hunter_masterscall",
        "id": "09704b27-46b4-4a33-a5b5-bc0f60360b0b",
        "modifierId": "97cecb8f-4f90-4c43-8a0e-d18e8a424303",
        "name": "Master's Call",
        "shortName": "Call"
      },
      "0b91fae5-c221-4816-8ae6-995b2ee34a04": {
        "affectedByModifierIds": [],
        "cooldown": 120,
        "game_id": 374227,
        "icon_name": "ability_evoker_hoverblack",
        "id": "0b91fae5-c221-4816-8ae6-995b2ee34a04",
        "name": "Zephyr",
        "shortName": "Zeph",
        "talentId": "0d992c62-362c-4dfc-924b-047f67be2ca8"
      },
      "12af0606-3665-4be2-9d2b-1d2776f7e827": {
        "affectedByModifierIds": [],
        "cooldown": 25,
        "game_id": 1044,
        "icon_name": "spell_holy_sealofvalor",
        "id": "12af0606-3665-4be2-9d2b-1d2776f7e827",
        "name": "Blessing of Freedom",
        "shortName": "Free"
      },
      "12de984d-13e9-416d-aa95-de2194c07251": {
        "affectedByModifierIds": [],
        "cooldown": 30,
        "game_id": 116841,
        "icon_name": "ability_monk_tigerslust",
        "id": "12de984d-13e9-416d-aa95-de2194c07251",
        "name": "Tiger's Lust",
        "shortName": "Lust",
        "talentId": "909f1f5b-a757-443d-b336-cd86f48d1dfd"
      },
      "13a13f04-2165-4dcc-8c30-e478e805ebb6": {
        "affectedByModifierIds": [],
        "cooldown": 60,
        "game_id": 370665,
        "icon_name": "ability_evoker_flywithme",
        "id": "13a13f04-2165-4dcc-8c30-e478e805ebb6",
        "name": "Rescue",
        "shortName": "Resc",
        "talentId": "73034b1a-bd86-4d63-986d-00767150da9d"
      },
      "149105e0-feb0-4535-bfc6-27239ada49ce": {
        "affectedByModifierIds": [],
        "cooldown": 120,
        "game_id": 51052,
        "icon_name": "spell_deathknight_antimagiczone",
        "id": "149105e0-feb0-4535-bfc6-27239ada49ce",
        "name": "Anti-Magic Zone",
        "shortName": "AMZ"
      },
      "16979d3b-3831-4d0b-8266-af4f5847ef58": {
        "affectedByModifierIds": [],
        "cooldown": 60,
        "game_id": 357170,
        "icon_name": "ability_evoker_timedilation",
        "id": "16979d3b-3831-4d0b-8266-af4f5847ef58",
        "name": "Time Dilation",
        "shortName": "Dia"
      },
      "16b54a37-4c8a-4a9e-974c-63ec64724a6d": {
        "affectedByModifierIds": [],
        "cooldown": 60,
        "game_id": 123040,
        "icon_name": "spell_shadow_soulleech_3",
        "id": "16b54a37-4c8a-4a9e-974c-63ec64724a6d",
        "name": "Mindbender",
        "shortName": "Bender",
        "talentId": "c2b8f54e-bc64-4f3f-bc20-342458ce8b34"
      },
      "1933d67f-b51a-4749-a6dc-012a6be0726b": {
        "affectedByModifierIds": [],
        "cooldown": 180,
        "game_id": 115310,
        "icon_name": "spell_monk_revival",
        "id": "1933d67f-b51a-4749-a6dc-012a6be0726b",
        "name": "Revival",
        "shortName": "Rev"
      },
      "1ace0b3c-c69b-4078-8dca-e1972e7e12b2": {
        "affectedByModifierIds": [],
        "cooldown": 180,
        "game_id": 47788,
        "icon_name": "spell_holy_guardianspirit",
        "id": "1ace0b3c-c69b-4078-8dca-e1972e7e12b2",
        "name": "Guardian Spirit",
        "shortName": "GS",
        "talentId": "128f953d-cfef-4cdf-9a9d-72da96c01bde"
      },
      "2108e3a6-f8f7-47f1-948b-eef23d7c3899": {
        "affectedByModifierIds": [],
        "cooldown": 60,
        "game_id": 102793,
        "icon_name": "spell_druid_ursolsvortex",
        "id": "2108e3a6-f8f7-47f1-948b-eef23d7c3899",
        "link_suffix": "",
        "name": "Ursol's Vortex",
        "shortName": "Vor",
        "talentId": "45b5c689-fc1e-40a1-bf50-e41365e7456c"
      },
      "226e9a3c-34a1-4cc6-a4c4-40192975733d": {
        "affectedByModifierIds": [],
        "cooldown": 120,
        "game_id": 374968,
        "icon_name": "ability_evoker_timespiral",
        "id": "226e9a3c-34a1-4cc6-a4c4-40192975733d",
        "name": "Time Spiral",
        "shortName": "Spiral",
        "talentId": "a30e6676-997f-4a3a-bb78-d353d6ab618d"
      },
      "2631857d-abdc-4f01-9639-48815ab13616": {
        "affectedByModifierIds": [],
        "cooldown": 90,
        "game_id": 124974,
        "icon_name": "achievement_zone_feralas",
        "id": "2631857d-abdc-4f01-9639-48815ab13616",
        "name": "Nature's Vigil",
        "shortName": "Vigil",
        "talentId": "07e2d1df-0a38-4075-adfc-998eb7def218"
      },
      "266fff1a-966f-42de-830e-b7edbedcfa86": {
        "affectedByModifierIds": [],
        "cooldown": 120,
        "game_id": 10060,
        "icon_name": "spell_holy_powerinfusion",
        "id": "266fff1a-966f-42de-830e-b7edbedcfa86",
        "name": "Power Infusion",
        "shortName": "PI",
        "talentId": "26fec4ad-7893-4450-a0d4-c0a2352b1f4d"
      },
      "2bce4547-fce7-4d62-b894-2018ef2589ef": {
        "affectedByModifierIds": [],
        "cooldown": 120,
        "game_id": 6940,
        "icon_name": "spell_holy_sealofsacrifice",
        "id": "2bce4547-fce7-4d62-b894-2018ef2589ef",
        "name": "Blessing of Sacrifice",
        "shortName": "Sac"
      },
      "2d0bf39e-ccef-44b9-b8a2-c6ccf254fbc9": {
        "affectedByModifierIds": [],
        "cooldown": 60,
        "game_id": 375576,
        "icon_name": "ability_bastion_paladin",
        "id": "2d0bf39e-ccef-44b9-b8a2-c6ccf254fbc9",
        "name": "Divine Toll",
        "shortName": "Toll",
        "talentId": "1bb6cb6a-b5f4-42b0-bb16-93795ebac03e"
      },
      "2dfdca50-d43e-4051-9889-86a0af8e4d11": {
        "affectedByModifierIds": [],
        "cooldown": 30,
        "game_id": 116841,
        "icon_name": "ability_monk_tigerslust",
        "id": "2dfdca50-d43e-4051-9889-86a0af8e4d11",
        "name": "Tiger's Lust",
        "shortName": "Lust",
        "talentId": "dc690ae9-da03-4789-ba73-6a34a9c9f4b0"
      },
      "2e788ebd-4f2f-4a77-8cad-fd108af4a159": {
        "affectedByModifierIds": [],
        "cooldown": 90,
        "game_id": 102342,
        "icon_name": "spell_druid_ironbark",
        "id": "2e788ebd-4f2f-4a77-8cad-fd108af4a159",
        "name": "Ironbark",
        "shortName": "IB"
      },
      "30f48251-6f5b-4d6b-b2be-c04274a1e1f2": {
        "affectedByModifierIds": [],
        "cooldown": 120,
        "game_id": 192077,
        "icon_name": "ability_shaman_windwalktotem",
        "id": "30f48251-6f5b-4d6b-b2be-c04274a1e1f2",
        "name": "Wind Rush Totem",
        "shortName": "WRT",
        "talentId": "176aea1a-5c86-40b5-bf15-f978497cdc97"
      },
      "31fdaf76-04ec-434d-a817-c022448c3678": {
        "affectedByModifierIds": [],
        "cooldown": 300,
        "game_id": 370511,
        "icon_name": "inv_potion_49",
        "id": "31fdaf76-04ec-434d-a817-c022448c3678",
        "name": "HP Pot",
        "shortName": "Pot",
        "talentId": "b13f131b-222d-481c-93cb-fe4ac8e4ab9e"
      },
      "359100cf-3a6a-4ea5-b2b3-5863e4c0da04": {
        "affectedByModifierIds": [],
        "cooldown": 120,
        "game_id": 406732,
        "icon_name": "ability_evoker_stretchtime",
        "id": "359100cf-3a6a-4ea5-b2b3-5863e4c0da04",
        "name": "Spatial Paradox",
        "shortName": "Para",
        "talentId": "aa664140-7871-414a-ac39-5b19c0f56efc"
      },
      "36e3f2a2-2ab9-4115-9a36-9a66c5a8ebd5": {
        "affectedByModifierIds": [],
        "cooldown": 120,
        "game_id": 383269,
        "icon_name": "ability_maldraxxus_deathknight",
        "id": "36e3f2a2-2ab9-4115-9a36-9a66c5a8ebd5",
        "link_suffix": "",
        "name": "Abomination Limb",
        "shortName": "Abom",
        "talentId": "36b1b8cd-86d9-43fd-92b7-ac5b1198cd07"
      },
      "38094d11-eef8-4047-ae8e-b8e513ee7da8": {
        "affectedByModifierIds": [],
        "cooldown": 180,
        "game_id": 186265,
        "icon_name": "ability_hunter_pet_turtle",
        "id": "38094d11-eef8-4047-ae8e-b8e513ee7da8",
        "name": "Aspect of the Turtle",
        "shortName": "Turtle"
      },
      "38e8bdc2-7193-4359-b3bb-5ef89e6df63f": {
        "affectedByModifierIds": [],
        "cooldown": 300,
        "game_id": 1022,
        "icon_name": "spell_holy_sealofprotection",
        "id": "38e8bdc2-7193-4359-b3bb-5ef89e6df63f",
        "name": "Blessing of Protection",
        "shortName": "BoP",
        "talentId": "785ffa5a-ad28-4cdc-8d55-d1035e67b2fc"
      },
      "3b16750b-c297-4cc0-9ded-5151749bc1fe": {
        "affectedByModifierIds": [],
        "cooldown": 120,
        "game_id": 51052,
        "icon_name": "spell_deathknight_antimagiczone",
        "id": "3b16750b-c297-4cc0-9ded-5151749bc1fe",
        "name": "Anti-Magic Zone",
        "shortName": "AMZ"
      },
      "491d48b9-059d-4d04-904f-2df4b4ef31eb": {
        "affectedByModifierIds": [],
        "cooldown": 180,
        "game_id": 108285,
        "icon_name": "ability_shaman_multitotemactivation",
        "id": "491d48b9-059d-4d04-904f-2df4b4ef31eb",
        "link_suffix": "",
        "name": "Totemic Recall",
        "shortName": "Recall",
        "talentId": "246b8dc0-68dc-447e-bed9-27137dbcf377"
      },
      "4ca718b9-1e94-4b2d-8988-18fbb6b3bfdc": {
        "affectedByModifierIds": [],
        "cooldown": 90,
        "game_id": 246287,
        "icon_name": "spell_holy_divineillumination",
        "id": "4ca718b9-1e94-4b2d-8988-18fbb6b3bfdc",
        "name": "Evang",
        "shortName": "Evang"
      },
      "4dcb852c-13d1-4f98-b290-6b7448e12c83": {
        "affectedByModifierIds": [],
        "cooldown": 300,
        "game_id": 207399,
        "icon_name": "spell_nature_reincarnation",
        "id": "4dcb852c-13d1-4f98-b290-6b7448e12c83",
        "name": "Ancestral Protection Totem",
        "shortName": "APT",
        "talentId": "7b46fd01-71ff-4529-b389-36572f789c27"
      },
      "5171e67e-edba-4ca5-a90a-20216088e900": {
        "affectedByModifierIds": [],
        "cooldown": 120,
        "game_id": 106898,
        "icon_name": "spell_druid_stampedingroar_cat",
        "id": "5171e67e-edba-4ca5-a90a-20216088e900",
        "name": "Stampeding Roar",
        "shortName": "Roar"
      },
      "546b181c-e440-4a39-a5d6-a7760a09526f": {
        "affectedByModifierIds": [],
        "cooldown": 60,
        "game_id": 102793,
        "icon_name": "spell_druid_ursolsvortex",
        "id": "546b181c-e440-4a39-a5d6-a7760a09526f",
        "link_suffix": "",
        "name": "Ursol's Vortex",
        "shortName": "Vor",
        "talentId": "b3ec93a1-6250-452a-ab54-e85e52924163"
      },
      "56d42104-e78f-46d5-9f56-a7e2bc8ca6ca": {
        "affectedByModifierIds": [],
        "cooldown": 120,
        "game_id": 6940,
        "icon_name": "spell_holy_sealofsacrifice",
        "id": "56d42104-e78f-46d5-9f56-a7e2bc8ca6ca",
        "name": "Blessing of Sacrifice",
        "shortName": "Sac",
        "talentId": "d740f1d1-23b0-4047-8ba1-d81aad23336b"
      },
      "58faeff0-a646-4a51-a1fa-5edf41381f34": {
        "affectedByModifierIds": [],
        "cooldown": 300,
        "game_id": 642,
        "icon_name": "spell_holy_divineshield",
        "id": "58faeff0-a646-4a51-a1fa-5edf41381f34",
        "name": "Divine Shield",
        "shortName": "Div"
      },
      "5d50199c-9064-4adb-8d76-3e2651510e31": {
        "affectedByModifierIds": [],
        "cooldown": 300,
        "game_id": 642,
        "icon_name": "spell_holy_divineshield",
        "id": "5d50199c-9064-4adb-8d76-3e2651510e31",
        "name": "Divine Shield",
        "shortName": "Div"
      },
      "5ed0a91e-1880-4f9a-b644-4c13470a61e5": {
        "affectedByModifierIds": [],
        "cooldown": 45,
        "game_id": 53271,
        "icon_name": "ability_hunter_masterscall",
        "id": "5ed0a91e-1880-4f9a-b644-4c13470a61e5",
        "modifierId": "97cecb8f-4f90-4c43-8a0e-d18e8a424303",
        "name": "Master's Call",
        "shortName": "Call"
      },
      "6322bfa2-4658-493d-ac8d-4dce32f0d793": {
        "affectedByModifierIds": [],
        "cooldown": 120,
        "game_id": 374968,
        "icon_name": "ability_evoker_timespiral",
        "id": "6322bfa2-4658-493d-ac8d-4dce32f0d793",
        "name": "Time Spiral",
        "shortName": "Spiral",
        "talentId": "4765648f-fc35-4305-bdce-e4353eec9c2c"
      },
      "63e24cd3-74af-4050-a6c1-091a4854ed98": {
        "affectedByModifierIds": [],
        "cooldown": 180,
        "game_id": 29166,
        "icon_name": "spell_nature_lightning",
        "id": "63e24cd3-74af-4050-a6c1-091a4854ed98",
        "name": "Innervate",
        "shortName": "Inn",
        "talentId": "81b03fbd-2ac3-49d1-b0d7-0d8aaa97371c"
      },
      "6583c72c-4b79-4435-bae9-fcc1b5c32d17": {
        "affectedByModifierIds": [],
        "cooldown": 180,
        "game_id": 414660,
        "icon_name": "ability_racial_magicalresistance",
        "id": "6583c72c-4b79-4435-bae9-fcc1b5c32d17",
        "name": "Mass Barrier",
        "shortName": "Barrier",
        "talentId": "40039152-7e24-4b87-9693-459badf45081"
      },
      "688d3cff-a59f-4bc8-8c67-84a616649881": {
        "affectedByModifierIds": [],
        "cooldown": 120,
        "game_id": 32375,
        "icon_name": "spell_arcane_massdispel",
        "id": "688d3cff-a59f-4bc8-8c67-84a616649881",
        "name": "Mass Dispel",
        "shortName": "Mass",
        "talentId": "59502386-a715-4059-9eba-bf5539df99ac"
      },
      "6a8f3c04-6fc2-4757-8a68-84d59c7b3e46": {
        "affectedByModifierIds": [],
        "cooldown": 120,
        "game_id": 106898,
        "icon_name": "spell_druid_stampedingroar_cat",
        "id": "6a8f3c04-6fc2-4757-8a68-84d59c7b3e46",
        "name": "Stampeding Roar",
        "shortName": "Roar"
      },
      "6e002afb-b81e-45ff-acbb-049081b3d052": {
        "affectedByModifierIds": [],
        "cooldown": 180,
        "game_id": 414660,
        "icon_name": "ability_racial_magicalresistance",
        "id": "6e002afb-b81e-45ff-acbb-049081b3d052",
        "name": "Mass Barrier",
        "shortName": "Barrier",
        "talentId": "e4ef9154-7c60-4f82-b7f4-aee7e072bea1"
      },
      "755896e9-8f8d-4262-b481-78b35619c227": {
        "affectedByModifierIds": [],
        "cooldown": 180,
        "game_id": 97462,
        "icon_name": "ability_warrior_rallyingcry",
        "id": "755896e9-8f8d-4262-b481-78b35619c227",
        "name": "Rallying Cry",
        "shortName": "RC"
      },
      "76430eb8-165c-4f9f-a619-4ee302197f32": {
        "affectedByModifierIds": [],
        "cooldown": 120,
        "game_id": 116849,
        "icon_name": "ability_monk_chicocoon",
        "id": "76430eb8-165c-4f9f-a619-4ee302197f32",
        "name": "Life Cocoon",
        "shortName": "Coco"
      },
      "781ef5af-1d36-4492-bc2f-43ec32d57e34": {
        "affectedByModifierIds": [],
        "cooldown": 25,
        "game_id": 1044,
        "icon_name": "spell_holy_sealofvalor",
        "id": "781ef5af-1d36-4492-bc2f-43ec32d57e34",
        "name": "Blessing of Freedom",
        "shortName": "Free"
      },
      "7917bfe4-1e09-4e4a-94ff-4afeb3745797": {
        "affectedByModifierIds": [],
        "cooldown": 45,
        "game_id": 53271,
        "icon_name": "ability_hunter_masterscall",
        "id": "7917bfe4-1e09-4e4a-94ff-4afeb3745797",
        "modifierId": "97cecb8f-4f90-4c43-8a0e-d18e8a424303",
        "name": "Master's Call",
        "shortName": "Call"
      },
      "7aeb468b-c67a-44ce-a38e-f7ce21d5abad": {
        "affectedByModifierIds": [],
        "cooldown": 120,
        "game_id": 32375,
        "icon_name": "spell_arcane_massdispel",
        "id": "7aeb468b-c67a-44ce-a38e-f7ce21d5abad",
        "name": "Mass Dispel",
        "shortName": "Mass",
        "talentId": "a9b0335f-6b6c-4acd-8ebb-e00ff27061f3"
      },
      "7ceb50d9-f44b-4ff8-bf75-5a432b340c0d": {
        "affectedByModifierIds": [],
        "cooldown": 180,
        "game_id": 325197,
        "icon_name": "inv_pet_cranegod",
        "id": "7ceb50d9-f44b-4ff8-bf75-5a432b340c0d",
        "name": "Invoke Chi-Ji, the Red Crane",
        "shortName": "Chi",
        "talentId": "1f8e2d40-918d-4603-a15c-59423e2585d7"
      },
      "7d7162a5-7e78-4957-973d-1b226afd667c": {
        "affectedByModifierIds": [],
        "cooldown": 90,
        "game_id": 124974,
        "icon_name": "achievement_zone_feralas",
        "id": "7d7162a5-7e78-4957-973d-1b226afd667c",
        "name": "Nature's Vigil",
        "shortName": "Vigil",
        "talentId": "24a1ecf6-a951-4652-bd26-2d6b12a3262b"
      },
      "7ec6fd94-a652-4491-a1b7-32a977ab331e": {
        "affectedByModifierIds": [],
        "cooldown": 300,
        "game_id": 204018,
        "icon_name": "spell_holy_blessingofprotection",
        "id": "7ec6fd94-a652-4491-a1b7-32a977ab331e",
        "name": "Blessing of Spellwarding",
        "shortName": "Ward"
      },
      "7f8a2f91-f4c5-44f0-b88f-8069484976e1": {
        "affectedByModifierIds": [],
        "cooldown": 180,
        "game_id": 97462,
        "icon_name": "ability_warrior_rallyingcry",
        "id": "7f8a2f91-f4c5-44f0-b88f-8069484976e1",
        "name": "Rallying Cry",
        "shortName": "RC"
      },
      "8350ad72-337c-4c95-844c-18eea40a8c8b": {
        "affectedByModifierIds": [],
        "cooldown": 720,
        "game_id": 265202,
        "icon_name": "ability_priest_archangel",
        "id": "8350ad72-337c-4c95-844c-18eea40a8c8b",
        "name": "Holy Word: Salvation",
        "shortName": "Salv",
        "talentId": "dcc4d8cc-cd6e-4b5d-8ce1-d22b0695212a"
      },
      "83f198c3-72fe-45a3-8a71-23e848414d30": {
        "affectedByModifierIds": [],
        "cooldown": 180,
        "game_id": 29166,
        "icon_name": "spell_nature_lightning",
        "id": "83f198c3-72fe-45a3-8a71-23e848414d30",
        "name": "Innervate",
        "shortName": "Inn",
        "talentId": "7351775e-92b7-478f-a030-104aaf1d6adc"
      },
      "864c11d9-76e9-46bc-8d57-83a78694d5c3": {
        "affectedByModifierIds": [],
        "cooldown": 180,
        "game_id": 33891,
        "icon_name": "ability_druid_improvedtreeform",
        "id": "864c11d9-76e9-46bc-8d57-83a78694d5c3",
        "name": "Incarnation: Tree of Life",
        "shortName": "Tree",
        "talentId": "3c45d7a2-9e52-4017-9f18-3014ffe0e430"
      },
      "87749372-54d2-419f-916d-7799b8d3f40d": {
        "affectedByModifierIds": [],
        "cooldown": 120,
        "game_id": 406732,
        "icon_name": "ability_evoker_stretchtime",
        "id": "87749372-54d2-419f-916d-7799b8d3f40d",
        "name": "Spatial Paradox",
        "shortName": "Para",
        "talentId": "cbf60eb9-cf97-4773-9ac7-0d7604dedaf0"
      },
      "88024cd3-bfc6-42c5-a1b5-a277b51407d8": {
        "affectedByModifierIds": [],
        "cooldown": 120,
        "game_id": 383269,
        "icon_name": "ability_maldraxxus_deathknight",
        "id": "88024cd3-bfc6-42c5-a1b5-a277b51407d8",
        "link_suffix": "",
        "name": "Abomination Limb",
        "shortName": "Abom",
        "talentId": "767e54f0-88e8-417f-9d8a-e487ca01fc6a"
      },
      "8aec93d2-2aff-49ec-adc7-7c7dacd98380": {
        "affectedByModifierIds": [],
        "cooldown": 60,
        "game_id": 119381,
        "icon_name": "ability_monk_legsweep",
        "id": "8aec93d2-2aff-49ec-adc7-7c7dacd98380",
        "link_suffix": "",
        "name": "Leg Sweep",
        "shortName": "Sweep"
      },
      "9002f891-b356-4f67-9c0f-f7e512ddb5ef": {
        "affectedByModifierIds": [],
        "cooldown": 120,
        "game_id": 192077,
        "icon_name": "ability_shaman_windwalktotem",
        "id": "9002f891-b356-4f67-9c0f-f7e512ddb5ef",
        "name": "Wind Rush Totem",
        "shortName": "WRT",
        "talentId": "6414c5fb-36ad-430f-ae2b-edaa0a58bf31"
      },
      "905c4d07-80a8-4d0c-97d5-d29c0bde98ba": {
        "affectedByModifierIds": [],
        "cooldown": 1000,
        "game_id": 6262,
        "icon_name": "warlock_-healthstone",
        "id": "905c4d07-80a8-4d0c-97d5-d29c0bde98ba",
        "name": "Healthstone",
        "shortName": "HS",
        "talentId": "496f5f29-c065-4cfc-9cad-c7c31f51c188"
      },
      "91dc9c20-57a2-4220-92b8-6395b97d6bd5": {
        "affectedByModifierIds": [],
        "cooldown": 90,
        "game_id": 73325,
        "icon_name": "priest_spell_leapoffaith_a",
        "id": "91dc9c20-57a2-4220-92b8-6395b97d6bd5",
        "name": "Leap of Faith",
        "shortName": "Leap",
        "talentId": "e85a95e3-89cf-4a0a-8ecd-498d67ce906d"
      },
      "98043a6f-447a-4d3e-8eb6-44368e5ba2bd": {
        "affectedByModifierIds": [],
        "cooldown": 180,
        "game_id": 29166,
        "icon_name": "spell_nature_lightning",
        "id": "98043a6f-447a-4d3e-8eb6-44368e5ba2bd",
        "name": "Innervate",
        "shortName": "Inn",
        "talentId": "82799079-fa85-4f5e-879c-e65b685a5783"
      },
      "98a8efbd-f141-4487-9505-180b0ffb067f": {
        "affectedByModifierIds": [],
        "cooldown": 180,
        "game_id": 33206,
        "icon_name": "spell_holy_painsupression",
        "id": "98a8efbd-f141-4487-9505-180b0ffb067f",
        "name": "Pain Suppression",
        "shortName": "PS"
      },
      "99b1990f-4cce-4f10-8a2d-4a7c2f8b449b": {
        "affectedByModifierIds": [],
        "cooldown": 120,
        "game_id": 15286,
        "icon_name": "spell_shadow_unsummonbuilding",
        "id": "99b1990f-4cce-4f10-8a2d-4a7c2f8b449b",
        "link_suffix": "",
        "name": "Vampiric Embrace",
        "shortName": "Vamp",
        "talentId": "ca124356-8a91-4702-8f65-d5f36efb7f74"
      },
      "9bd01167-e150-4923-9a59-227797e713d0": {
        "affectedByModifierIds": [],
        "cooldown": 180,
        "game_id": 114052,
        "icon_name": "spell_fire_elementaldevastation",
        "id": "9bd01167-e150-4923-9a59-227797e713d0",
        "name": "Ascendance",
        "shortName": "Asc",
        "talentId": "c473579c-60b9-4a98-bd6e-75073994f1f3"
      },
      "9c6ad09a-828e-4c60-a9a2-c3d2f244d941": {
        "affectedByModifierIds": [],
        "cooldown": 180,
        "game_id": 414660,
        "icon_name": "ability_racial_magicalresistance",
        "id": "9c6ad09a-828e-4c60-a9a2-c3d2f244d941",
        "name": "Mass Barrier",
        "shortName": "Barrier",
        "talentId": "85050e0d-9137-4795-a826-d43e83b648bd"
      },
      "9cdb8790-b5a3-4d6e-9be8-f0146844df8c": {
        "affectedByModifierIds": [],
        "cooldown": 180,
        "game_id": 108280,
        "icon_name": "ability_shaman_healingtide",
        "id": "9cdb8790-b5a3-4d6e-9be8-f0146844df8c",
        "name": "Healing Tide Totem",
        "shortName": "HTT"
      },
      "a18258ed-6fbd-4a5b-928f-5664f54ba566": {
        "affectedByModifierIds": [],
        "cooldown": 90,
        "game_id": 124974,
        "icon_name": "achievement_zone_feralas",
        "id": "a18258ed-6fbd-4a5b-928f-5664f54ba566",
        "name": "Nature's Vigil",
        "shortName": "Vigil",
        "talentId": "90c7b081-5aa9-413d-a638-42961d68a966"
      },
      "a328e53b-28a9-4fa5-87e7-e71eeb7b2b5b": {
        "affectedByModifierIds": [],
        "cooldown": 300,
        "game_id": 642,
        "icon_name": "spell_holy_divineshield",
        "id": "a328e53b-28a9-4fa5-87e7-e71eeb7b2b5b",
        "name": "Divine Shield",
        "shortName": "Div"
      },
      "a351975d-4d53-440a-8fe5-13836f8e86e4": {
        "affectedByModifierIds": [],
        "cooldown": 120,
        "game_id": 383269,
        "icon_name": "ability_maldraxxus_deathknight",
        "id": "a351975d-4d53-440a-8fe5-13836f8e86e4",
        "link_suffix": "",
        "name": "Abomination Limb",
        "shortName": "Abom",
        "talentId": "2b36a255-0d1f-4edb-ac7d-2f9cca13bfa3"
      },
      "a5a8d118-41b4-4bfc-81c9-61453aec3832": {
        "affectedByModifierIds": [],
        "cooldown": 180,
        "game_id": 108285,
        "icon_name": "ability_shaman_multitotemactivation",
        "id": "a5a8d118-41b4-4bfc-81c9-61453aec3832",
        "link_suffix": "",
        "name": "Totemic Recall",
        "shortName": "Recall",
        "talentId": "37b9b1a4-c4e5-4290-be71-3eeab3bcf617"
      },
      "a779de5c-f483-4fa1-aa40-43581326f792": {
        "affectedByModifierIds": [],
        "cooldown": 120,
        "game_id": 10060,
        "icon_name": "spell_holy_powerinfusion",
        "id": "a779de5c-f483-4fa1-aa40-43581326f792",
        "name": "Power Infusion",
        "shortName": "PI",
        "talentId": "ec19073f-a8e0-4d9f-b011-66a417942590"
      },
      "a82b3af9-5f7f-4848-8a8c-9085a1e66a49": {
        "affectedByModifierIds": [],
        "cooldown": 120,
        "game_id": 359816,
        "icon_name": "ability_evoker_dreamflight",
        "id": "a82b3af9-5f7f-4848-8a8c-9085a1e66a49",
        "name": "Dream Flight",
        "shortName": "Dream",
        "talentId": "ab58d1d9-db4d-4e7a-a014-86eaa08c1611"
      },
      "a945fd6b-ec7b-42b4-8025-7671b2c79e6c": {
        "affectedByModifierIds": [],
        "cooldown": 180,
        "game_id": 186265,
        "icon_name": "ability_hunter_pet_turtle",
        "id": "a945fd6b-ec7b-42b4-8025-7671b2c79e6c",
        "name": "Aspect of the Turtle",
        "shortName": "Turtle"
      },
      "aa903e1f-9c6c-46b2-a3a1-1040686a4433": {
        "affectedByModifierIds": [],
        "cooldown": 180,
        "game_id": 97462,
        "icon_name": "ability_warrior_rallyingcry",
        "id": "aa903e1f-9c6c-46b2-a3a1-1040686a4433",
        "name": "Rallying Cry",
        "shortName": "RC"
      },
      "ab6f223c-68a1-479e-b033-e41f6fc8ea49": {
        "affectedByModifierIds": [],
        "cooldown": 60,
        "game_id": 119381,
        "icon_name": "ability_monk_legsweep",
        "id": "ab6f223c-68a1-479e-b033-e41f6fc8ea49",
        "link_suffix": "",
        "name": "Leg Sweep",
        "shortName": "Sweep"
      },
      "aec2b540-401c-4d38-a747-b6416e11b018": {
        "affectedByModifierIds": [],
        "cooldown": 120,
        "game_id": 6940,
        "icon_name": "spell_holy_sealofsacrifice",
        "id": "aec2b540-401c-4d38-a747-b6416e11b018",
        "name": "Blessing of Sacrifice",
        "shortName": "Sac",
        "talentId": "534403c0-3c0d-45b3-9ef1-e3783fa41c08"
      },
      "b73387fc-91ff-40f9-9fdf-0d855927d16e": {
        "affectedByModifierIds": [],
        "cooldown": 120,
        "game_id": 108281,
        "icon_name": "ability_shaman_ancestralguidance",
        "id": "b73387fc-91ff-40f9-9fdf-0d855927d16e",
        "name": "Ancestral Guidance",
        "shortName": "Guide",
        "talentId": "88aed695-3e44-4edc-9399-a9f0017c4acc"
      },
      "b8cb697b-d456-4489-9d61-d0a286129d55": {
        "affectedByModifierIds": [],
        "cooldown": 120,
        "game_id": 106898,
        "icon_name": "spell_druid_stampedingroar_cat",
        "id": "b8cb697b-d456-4489-9d61-d0a286129d55",
        "name": "Stampeding Roar",
        "shortName": "Roar"
      },
      "b9c5c635-ebd2-407e-a9c4-143df8566bce": {
        "affectedByModifierIds": [],
        "cooldown": 180,
        "game_id": 62618,
        "icon_name": "spell_holy_powerwordbarrier",
        "id": "b9c5c635-ebd2-407e-a9c4-143df8566bce",
        "name": "Power Word: Barrier",
        "shortName": "PW:B"
      },
      "baf7f1e4-f326-4ff2-9dfb-42d0f05f120e": {
        "affectedByModifierIds": [],
        "cooldown": 120,
        "game_id": 406732,
        "icon_name": "ability_evoker_stretchtime",
        "id": "baf7f1e4-f326-4ff2-9dfb-42d0f05f120e",
        "name": "Spatial Paradox",
        "shortName": "Para",
        "talentId": "cff1e89d-61b7-475f-8be5-f1b8e0e9badf"
      },
      "bc7f3a24-3640-4403-8e1d-5f327c0db931": {
        "affectedByModifierIds": [],
        "cooldown": 120,
        "game_id": 108281,
        "icon_name": "ability_shaman_ancestralguidance",
        "id": "bc7f3a24-3640-4403-8e1d-5f327c0db931",
        "name": "Ancestral Guidance",
        "shortName": "Guide",
        "talentId": "b2448fed-b273-4d91-897b-749bd8c26c12"
      },
      "bf98a80a-a8a5-4d0e-bc27-1e71fbacb7f9": {
        "affectedByModifierIds": [],
        "cooldown": 45,
        "game_id": 216331,
        "icon_name": "ability_paladin_veneration",
        "id": "bf98a80a-a8a5-4d0e-bc27-1e71fbacb7f9",
        "name": "Avenging Crusader",
        "shortName": "Crusa",
        "talentId": "816a3a32-a4d2-4cfb-aad8-47c749c6222f"
      },
      "c21f4b62-777b-408f-81ed-98ef91a62fb8": {
        "affectedByModifierIds": [],
        "cooldown": 30,
        "game_id": 116841,
        "icon_name": "ability_monk_tigerslust",
        "id": "c21f4b62-777b-408f-81ed-98ef91a62fb8",
        "name": "Tiger's Lust",
        "shortName": "Lust"
      },
      "c29a1e24-cdf1-4a90-8f66-0f710de6b95f": {
        "affectedByModifierIds": [],
        "cooldown": 180,
        "game_id": 370960,
        "icon_name": "ability_evoker_green_01",
        "id": "c29a1e24-cdf1-4a90-8f66-0f710de6b95f",
        "name": "Emerald Communion",
        "shortName": "Com",
        "talentId": "e9ed1039-2542-45a5-9a7e-0da17313acfa"
      },
      "c359b7b7-a981-4c4b-bb80-7bf57e1be922": {
        "affectedByModifierIds": [],
        "cooldown": 180,
        "game_id": 108285,
        "icon_name": "ability_shaman_multitotemactivation",
        "id": "c359b7b7-a981-4c4b-bb80-7bf57e1be922",
        "link_suffix": "",
        "name": "Totemic Recall",
        "shortName": "Recall",
        "talentId": "758b104b-e4db-4437-a728-06c0791981d6"
      },
      "c4104b9d-26b6-4cd2-8dc9-f346f94346c5": {
        "affectedByModifierIds": [],
        "cooldown": 300,
        "game_id": 1022,
        "icon_name": "spell_holy_sealofprotection",
        "id": "c4104b9d-26b6-4cd2-8dc9-f346f94346c5",
        "name": "Blessing of Protection",
        "shortName": "BoP",
        "talentId": "03d12b2f-f177-4460-9e0e-04238063e477"
      },
      "c71b94d6-8470-436b-afd8-1aee1981099d": {
        "affectedByModifierIds": [],
        "cooldown": 180,
        "game_id": 186265,
        "icon_name": "ability_hunter_pet_turtle",
        "id": "c71b94d6-8470-436b-afd8-1aee1981099d",
        "name": "Aspect of the Turtle",
        "shortName": "Turtle"
      },
      "c749dc6b-7e45-4a5c-beb5-67ebe7e908ab": {
        "affectedByModifierIds": [],
        "cooldown": 180,
        "game_id": 16191,
        "icon_name": "ability_shaman_manatidetotem",
        "id": "c749dc6b-7e45-4a5c-beb5-67ebe7e908ab",
        "name": "Mana Tide Totem",
        "shortName": "MTT",
        "talentId": "c895b503-d882-4b28-857e-82dd60f2767d"
      },
      "c79698a5-28cd-4797-88a8-e7d83df40d45": {
        "affectedByModifierIds": [],
        "cooldown": 120,
        "game_id": 32375,
        "icon_name": "spell_arcane_massdispel",
        "id": "c79698a5-28cd-4797-88a8-e7d83df40d45",
        "name": "Mass Dispel",
        "shortName": "Mass",
        "talentId": "8a23386b-bec3-4c9c-8b91-6f0978cbd9e8"
      },
      "ca1bd677-a9dd-4850-ac8f-5557466b2da3": {
        "affectedByModifierIds": [],
        "cooldown": 120,
        "game_id": 200183,
        "icon_name": "ability_priest_ascension",
        "id": "ca1bd677-a9dd-4850-ac8f-5557466b2da3",
        "link_suffix": "",
        "name": "Apotheosis",
        "shortName": "Apo",
        "talentId": "145705e0-34fa-408a-9c4c-0eb095164bd8"
      },
      "ca893cdb-27d4-4fdc-8534-4f61461ce940": {
        "affectedByModifierIds": [],
        "cooldown": 120,
        "game_id": 31884,
        "icon_name": "spell_holy_avenginewrath",
        "id": "ca893cdb-27d4-4fdc-8534-4f61461ce940",
        "link_suffix": "",
        "name": "Avenging Wrath",
        "shortName": "Wings",
        "talentId": "2588c632-df3c-4ac7-97c9-b3b2af36df74"
      },
      "cab7cdd0-1733-4f2b-9e3c-2f9dacb84cc8": {
        "affectedByModifierIds": [],
        "cooldown": 120,
        "game_id": 373905,
        "icon_name": "ability_vehicle_shellshieldgenerator_green",
        "id": "cab7cdd0-1733-4f2b-9e3c-2f9dacb84cc8",
        "name": "Personal 2min",
        "shortName": "Pers",
        "talentId": "94332795-35fc-4c49-bba0-18c103bb408e"
      },
      "cb1a07db-73ca-46da-abac-e8a5bbb4a6ad": {
        "affectedByModifierIds": [],
        "cooldown": 25,
        "game_id": 1044,
        "icon_name": "spell_holy_sealofvalor",
        "id": "cb1a07db-73ca-46da-abac-e8a5bbb4a6ad",
        "name": "Blessing of Freedom",
        "shortName": "Free",
        "talentId": "1576891d-9e1e-40ff-9df1-a49e099472a2"
      },
      "cb951cc4-f66a-401e-a3fc-2d8088ca2407": {
        "affectedByModifierIds": [],
        "cooldown": 180,
        "game_id": 64901,
        "icon_name": "spell_holy_symbolofhope",
        "id": "cb951cc4-f66a-401e-a3fc-2d8088ca2407",
        "name": "Symbol of Hope",
        "shortName": "Hope"
      },
      "cd92e6a0-814a-46f9-b63b-c3e41f965dd8": {
        "affectedByModifierIds": [],
        "cooldown": 120,
        "game_id": 374227,
        "icon_name": "ability_evoker_hoverblack",
        "id": "cd92e6a0-814a-46f9-b63b-c3e41f965dd8",
        "name": "Zephyr",
        "shortName": "Zeph",
        "talentId": "9a9316a3-8f95-4cb4-9587-8745777e125f"
      },
      "cf47dd1b-57ce-4ff0-90c1-0066a187718b": {
        "affectedByModifierIds": [],
        "cooldown": 300,
        "game_id": 196718,
        "icon_name": "ability_demonhunter_darkness",
        "id": "cf47dd1b-57ce-4ff0-90c1-0066a187718b",
        "link_suffix": "",
        "name": "Darkness",
        "shortName": "Dark",
        "talentId": "8c99b3d5-62d2-4672-bbec-50eb0f3c8fc2"
      },
      "cfb7415b-728a-43b6-a2f1-fb829c149c8c": {
        "affectedByModifierIds": [],
        "cooldown": 90,
        "game_id": 73325,
        "icon_name": "priest_spell_leapoffaith_a",
        "id": "cfb7415b-728a-43b6-a2f1-fb829c149c8c",
        "name": "Leap of Faith",
        "shortName": "Leap",
        "talentId": "270c2610-9e02-4240-8eb2-4cb9c551fbe3"
      },
      "d322ee3a-ae53-442b-a1cf-664f2d61d04b": {
        "affectedByModifierIds": [],
        "cooldown": 60,
        "game_id": 370665,
        "icon_name": "ability_evoker_flywithme",
        "id": "d322ee3a-ae53-442b-a1cf-664f2d61d04b",
        "name": "Rescue",
        "shortName": "Resc",
        "talentId": "fae8f28c-27b6-4cf9-8ed3-cb1bb3701924"
      },
      "d3e989d5-5153-45d5-a442-8fa2c926661c": {
        "affectedByModifierIds": [],
        "cooldown": 90,
        "game_id": 47536,
        "icon_name": "spell_holy_rapture",
        "id": "d3e989d5-5153-45d5-a442-8fa2c926661c",
        "name": "Rapt",
        "shortName": "Rapt"
      },
      "d8bcbe43-916e-4bae-aa75-b5d43a3c55cc": {
        "affectedByModifierIds": [],
        "cooldown": 120,
        "game_id": 108281,
        "icon_name": "ability_shaman_ancestralguidance",
        "id": "d8bcbe43-916e-4bae-aa75-b5d43a3c55cc",
        "name": "Ancestral Guidance",
        "shortName": "Guide",
        "talentId": "08b1232f-f4ea-4669-b3e1-62e89668784e"
      },
      "dbabf9cc-7f51-4727-8b44-c0cb6a1a4342": {
        "affectedByModifierIds": [],
        "cooldown": 180,
        "game_id": 64843,
        "icon_name": "spell_holy_divinehymn",
        "id": "dbabf9cc-7f51-4727-8b44-c0cb6a1a4342",
        "name": "Divine Hymn",
        "shortName": "Hymn"
      },
      "dcf29b11-b583-4da1-8e7b-eb072d5003d3": {
        "affectedByModifierIds": [],
        "cooldown": 300,
        "game_id": 196718,
        "icon_name": "ability_demonhunter_darkness",
        "id": "dcf29b11-b583-4da1-8e7b-eb072d5003d3",
        "link_suffix": "",
        "name": "Darkness",
        "shortName": "Dark",
        "talentId": "bbd1c3c3-96df-45f1-8c59-dea4fee0d9ca"
      },
      "e1d00dfa-fff5-424c-adef-7da054dc3897": {
        "affectedByModifierIds": [],
        "cooldown": 180,
        "game_id": 322118,
        "icon_name": "ability_monk_dragonkick",
        "id": "e1d00dfa-fff5-424c-adef-7da054dc3897",
        "link_suffix": "",
        "name": "Invoke Yu'lon, the Jade Serpent",
        "shortName": "Yulon",
        "talentId": "5268ec1f-cde9-4148-ad41-bb67a35df24c"
      },
      "e27a01f2-41c4-4f8f-ab6f-7b3e95a5d5a6": {
        "affectedByModifierIds": [],
        "cooldown": 60,
        "game_id": 102793,
        "icon_name": "spell_druid_ursolsvortex",
        "id": "e27a01f2-41c4-4f8f-ab6f-7b3e95a5d5a6",
        "link_suffix": "",
        "name": "Ursol's Vortex",
        "shortName": "Vor",
        "talentId": "37a85b35-ee30-4f8a-aad5-679ba20ee2eb"
      },
      "e4fc858c-8c0d-4dd3-a155-c970a14dba92": {
        "affectedByModifierIds": [],
        "cooldown": 90,
        "game_id": 200652,
        "icon_name": "inv_mace_2h_artifactsilverhand_d_01",
        "id": "e4fc858c-8c0d-4dd3-a155-c970a14dba92",
        "name": "Tyr's Deliverance",
        "shortName": "Tyr",
        "talentId": "266e2fbc-b0a8-44e3-8332-40ad6b7310f2"
      },
      "e791e627-d68b-4dcc-9e37-ce471e86b268": {
        "affectedByModifierIds": [],
        "cooldown": 60,
        "game_id": 119381,
        "icon_name": "ability_monk_legsweep",
        "id": "e791e627-d68b-4dcc-9e37-ce471e86b268",
        "link_suffix": "",
        "name": "Leg Sweep",
        "shortName": "Sweep"
      },
      "e7f75540-166c-4cbb-a69d-3589acd7691e": {
        "affectedByModifierIds": [],
        "cooldown": 120,
        "game_id": 374968,
        "icon_name": "ability_evoker_timespiral",
        "id": "e7f75540-166c-4cbb-a69d-3589acd7691e",
        "name": "Time Spiral",
        "shortName": "Spiral",
        "talentId": "ba35bc19-6a14-4fe9-99a9-5f86a1d2ba69"
      },
      "e927283d-2e30-47d0-a11c-d29bc0da0ffd": {
        "affectedByModifierIds": [],
        "cooldown": 120,
        "game_id": 192077,
        "icon_name": "ability_shaman_windwalktotem",
        "id": "e927283d-2e30-47d0-a11c-d29bc0da0ffd",
        "name": "Wind Rush Totem",
        "shortName": "WRT",
        "talentId": "446f9fbe-49ec-44ae-b856-c8631d8ef5b8"
      },
      "ea074334-e633-46bd-9958-3fdb463068fd": {
        "affectedByModifierIds": [],
        "cooldown": 120,
        "game_id": 51052,
        "icon_name": "spell_deathknight_antimagiczone",
        "id": "ea074334-e633-46bd-9958-3fdb463068fd",
        "name": "Anti-Magic Zone",
        "shortName": "AMZ"
      },
      "ebb778df-bef7-4ffa-8820-195aed3e8f40": {
        "affectedByModifierIds": [],
        "cooldown": 120,
        "game_id": 391528,
        "icon_name": "ability_ardenweald_druid",
        "id": "ebb778df-bef7-4ffa-8820-195aed3e8f40",
        "name": "Convoke the Spirits",
        "shortName": "Con",
        "talentId": "15c1f077-0c6c-4a3a-a75a-02bff29b5664"
      },
      "ed7bf7a5-d61b-4276-9182-c8ee0cad090e": {
        "affectedByModifierIds": [],
        "cooldown": 180,
        "game_id": 34433,
        "icon_name": "spell_shadow_shadowfiend",
        "id": "ed7bf7a5-d61b-4276-9182-c8ee0cad090e",
        "name": "Shadowfiend",
        "shortName": "Fiend"
      },
      "ef6d59d7-7522-4b4c-9111-9f554edd4614": {
        "affectedByModifierIds": [],
        "cooldown": 120,
        "game_id": 108199,
        "icon_name": "ability_deathknight_aoedeathgrip",
        "id": "ef6d59d7-7522-4b4c-9111-9f554edd4614",
        "link_suffix": "",
        "name": "Gorefiend's Grasp",
        "shortName": "Grasp",
        "talentId": "467b7328-32ae-44e2-8532-3f958a7badb8"
      },
      "f1731241-a892-464e-8b03-ca55f727e65a": {
        "affectedByModifierIds": [],
        "cooldown": 180,
        "game_id": 740,
        "icon_name": "spell_nature_tranquility",
        "id": "f1731241-a892-464e-8b03-ca55f727e65a",
        "name": "Tranquility",
        "shortName": "Tranq"
      },
      "f5761e2f-fb64-4165-afb2-7be13df8da66": {
        "affectedByModifierIds": [],
        "cooldown": 60,
        "game_id": 102793,
        "icon_name": "spell_druid_ursolsvortex",
        "id": "f5761e2f-fb64-4165-afb2-7be13df8da66",
        "link_suffix": "",
        "name": "Ursol's Vortex",
        "shortName": "Vor",
        "talentId": "4d782bee-99f7-4568-9fad-84058719b8a3"
      },
      "f5ef4208-c8b1-4ac0-9e72-2d5fd1588b69": {
        "affectedByModifierIds": [],
        "cooldown": 240,
        "game_id": 363534,
        "icon_name": "ability_evoker_rewind",
        "id": "f5ef4208-c8b1-4ac0-9e72-2d5fd1588b69",
        "name": "Rewind",
        "shortName": "Rew"
      },
      "fb72136a-1814-46eb-bf51-4dc08461274d": {
        "affectedByModifierIds": [],
        "cooldown": 300,
        "game_id": 1022,
        "icon_name": "spell_holy_sealofprotection",
        "id": "fb72136a-1814-46eb-bf51-4dc08461274d",
        "name": "Blessing of Protection",
        "shortName": "BoP",
        "talentId": "3238af4a-e6bf-44a7-befe-0b3bb7a3d95d"
      },
      "fe0aa554-2490-4bdc-b674-0eec49b04bc4": {
        "affectedByModifierIds": [],
        "cooldown": 120,
        "game_id": 374227,
        "icon_name": "ability_evoker_hoverblack",
        "id": "fe0aa554-2490-4bdc-b674-0eec49b04bc4",
        "name": "Zephyr",
        "shortName": "Zeph",
        "talentId": "29d23e3f-53ed-4fa9-a788-39af5ac8cc21"
      }
    },
    "talentsById": {
      "02d314aa-f05d-414b-8f82-15893e8b198f": {
        "game_id": 200209,
        "icon_name": "ability_priest_pathofthedevout",
        "id": "02d314aa-f05d-414b-8f82-15893e8b198f",
        "name": "Guardian Angel",
        "shortName": "GA",
        "specId": "d122a0b5-d857-4bc5-a456-c7250f8f6690"
      },
      "03d12b2f-f177-4460-9e0e-04238063e477": {
        "game_id": 1022,
        "icon_name": "spell_holy_sealofprotection",
        "id": "03d12b2f-f177-4460-9e0e-04238063e477",
        "name": "Blessing of Protection",
        "shortName": "BoP",
        "specId": "e1af3b62-ddf5-4369-a528-dab8ab94d366"
      },
      "06ef5380-b89d-40ca-b37b-2b32edc3bf29": {
        "game_id": 390620,
        "icon_name": "ability_priest_savinggrace",
        "id": "06ef5380-b89d-40ca-b37b-2b32edc3bf29",
        "name": "Move with Grace",
        "shortName": "Grace",
        "specId": "d122a0b5-d857-4bc5-a456-c7250f8f6690"
      },
      "07e2d1df-0a38-4075-adfc-998eb7def218": {
        "game_id": 124974,
        "icon_name": "achievement_zone_feralas",
        "id": "07e2d1df-0a38-4075-adfc-998eb7def218",
        "name": "Nature's Vigil",
        "shortName": "Vigil",
        "specId": "575905ae-cdc7-44c8-946c-861d50111b6d"
      },
      "08b1232f-f4ea-4669-b3e1-62e89668784e": {
        "game_id": 108281,
        "icon_name": "ability_shaman_ancestralguidance",
        "id": "08b1232f-f4ea-4669-b3e1-62e89668784e",
        "name": "Ancestral Guidance",
        "shortName": "Guide",
        "specId": "51daa0f0-df16-4983-ae44-e11b5f9b3edb"
      },
      "0d992c62-362c-4dfc-924b-047f67be2ca8": {
        "game_id": 374227,
        "icon_name": "ability_evoker_hoverblack",
        "id": "0d992c62-362c-4dfc-924b-047f67be2ca8",
        "name": "Zephyr",
        "shortName": "Zeph",
        "specId": "48a205f0-5e24-4382-9e0b-3c06cfc1b873"
      },
      "0de55575-ade5-426f-b47c-584e507ac416": {
        "game_id": 384820,
        "icon_name": "spell_holy_sealofsacrifice",
        "id": "0de55575-ade5-426f-b47c-584e507ac416",
        "name": "Sacrifice of the Just",
        "shortName": "Just",
        "specId": "8fceebcc-a93b-4692-81ea-331b2e59d43d"
      },
      "0fc53a13-f373-47e8-bd6e-55f9a5e6bb09": {
        "game_id": 383011,
        "icon_name": "ability_shaman_multitotemactivation",
        "id": "0fc53a13-f373-47e8-bd6e-55f9a5e6bb09",
        "link_suffix": "",
        "name": "Call of the Elements",
        "shortName": "CotE",
        "specId": "51daa0f0-df16-4983-ae44-e11b5f9b3edb"
      },
      "10f830ed-9048-4865-97fb-ffc816f65f66": {
        "game_id": 73325,
        "icon_name": "priest_spell_leapoffaith_a",
        "id": "10f830ed-9048-4865-97fb-ffc816f65f66",
        "name": "Leap of Faith",
        "shortName": "Leap",
        "specId": "67a45712-192e-4916-ad57-d9a13124fea6"
      },
      "128f953d-cfef-4cdf-9a9d-72da96c01bde": {
        "game_id": 47788,
        "icon_name": "spell_holy_guardianspirit",
        "id": "128f953d-cfef-4cdf-9a9d-72da96c01bde",
        "name": "Guardian Spirit",
        "shortName": "GS",
        "specId": "d122a0b5-d857-4bc5-a456-c7250f8f6690"
      },
      "13db282d-b721-475d-aa6e-bd131791db66": {
        "game_id": 344359,
        "icon_name": "ability_monk_dpsstance",
        "id": "13db282d-b721-475d-aa6e-bd131791db66",
        "link_suffix": "?def=129821&rank=2",
        "name": "Ancient Arts (2/2)",
        "shortName": "Arts",
        "specId": "18dad85c-ac2c-4aac-b0f8-e0fc4b8633e6"
      },
      "145705e0-34fa-408a-9c4c-0eb095164bd8": {
        "game_id": 200183,
        "icon_name": "ability_priest_ascension",
        "id": "145705e0-34fa-408a-9c4c-0eb095164bd8",
        "link_suffix": "",
        "name": "Apotheosis",
        "shortName": "Apo",
        "specId": "d122a0b5-d857-4bc5-a456-c7250f8f6690"
      },
      "1576891d-9e1e-40ff-9df1-a49e099472a2": {
        "game_id": 1044,
        "icon_name": "spell_holy_sealofvalor",
        "id": "1576891d-9e1e-40ff-9df1-a49e099472a2",
        "name": "Blessing of Freedom",
        "shortName": "Free",
        "specId": "8fceebcc-a93b-4692-81ea-331b2e59d43d"
      },
      "15c1f077-0c6c-4a3a-a75a-02bff29b5664": {
        "game_id": 391528,
        "icon_name": "ability_ardenweald_druid",
        "id": "15c1f077-0c6c-4a3a-a75a-02bff29b5664",
        "name": "Convoke the Spirits",
        "shortName": "Con",
        "specId": "72947601-4270-4e1e-b917-25aacaa6d3e0"
      },
      "160dfe8a-fd9e-4a9f-b3b7-844269786fc4": {
        "game_id": 344359,
        "icon_name": "ability_monk_dpsstance",
        "id": "160dfe8a-fd9e-4a9f-b3b7-844269786fc4",
        "link_suffix": "?def=129821&rank=1",
        "name": "Ancient Arts (1/2)",
        "shortName": "Arts",
        "specId": "da2dc773-9412-4b11-ab2b-7d06e200b9d3"
      },
      "176aea1a-5c86-40b5-bf15-f978497cdc97": {
        "game_id": 192077,
        "icon_name": "ability_shaman_windwalktotem",
        "id": "176aea1a-5c86-40b5-bf15-f978497cdc97",
        "name": "Wind Rush Totem",
        "shortName": "WRT",
        "specId": "af2ca3dc-34c9-4632-98d2-6ea12a2a72f9"
      },
      "1bb6cb6a-b5f4-42b0-bb16-93795ebac03e": {
        "game_id": 375576,
        "icon_name": "ability_bastion_paladin",
        "id": "1bb6cb6a-b5f4-42b0-bb16-93795ebac03e",
        "name": "Divine Toll",
        "shortName": "Toll",
        "specId": "e1af3b62-ddf5-4369-a528-dab8ab94d366"
      },
      "1f8e2d40-918d-4603-a15c-59423e2585d7": {
        "game_id": 325197,
        "icon_name": "inv_pet_cranegod",
        "id": "1f8e2d40-918d-4603-a15c-59423e2585d7",
        "name": "Invoke Chi-Ji, the Red Crane",
        "shortName": "Chi",
        "specId": "da2dc773-9412-4b11-ab2b-7d06e200b9d3"
      },
      "20670122-e9f4-464e-ab04-5c758107c629": {
        "game_id": 383011,
        "icon_name": "ability_shaman_multitotemactivation",
        "id": "20670122-e9f4-464e-ab04-5c758107c629",
        "link_suffix": "",
        "name": "Call of the Elements",
        "shortName": "CotE",
        "specId": "af2ca3dc-34c9-4632-98d2-6ea12a2a72f9"
      },
      "246b8dc0-68dc-447e-bed9-27137dbcf377": {
        "game_id": 108285,
        "icon_name": "ability_shaman_multitotemactivation",
        "id": "246b8dc0-68dc-447e-bed9-27137dbcf377",
        "link_suffix": "",
        "name": "Totemic Recall",
        "shortName": "Recall",
        "specId": "51daa0f0-df16-4983-ae44-e11b5f9b3edb"
      },
      "24a1ecf6-a951-4652-bd26-2d6b12a3262b": {
        "game_id": 124974,
        "icon_name": "achievement_zone_feralas",
        "id": "24a1ecf6-a951-4652-bd26-2d6b12a3262b",
        "name": "Nature's Vigil",
        "shortName": "Vigil",
        "specId": "be905ae2-ec32-49bf-bc82-ef1cbf83ce9f"
      },
      "2588c632-df3c-4ac7-97c9-b3b2af36df74": {
        "game_id": 31884,
        "icon_name": "spell_holy_avenginewrath",
        "id": "2588c632-df3c-4ac7-97c9-b3b2af36df74",
        "link_suffix": "",
        "name": "Avenging Wrath",
        "shortName": "Wings",
        "specId": "e1af3b62-ddf5-4369-a528-dab8ab94d366"
      },
      "266e2fbc-b0a8-44e3-8332-40ad6b7310f2": {
        "game_id": 200652,
        "icon_name": "inv_mace_2h_artifactsilverhand_d_01",
        "id": "266e2fbc-b0a8-44e3-8332-40ad6b7310f2",
        "name": "Tyr's Deliverance",
        "shortName": "Tyr",
        "specId": "e1af3b62-ddf5-4369-a528-dab8ab94d366"
      },
      "26fec4ad-7893-4450-a0d4-c0a2352b1f4d": {
        "game_id": 10060,
        "icon_name": "spell_holy_powerinfusion",
        "id": "26fec4ad-7893-4450-a0d4-c0a2352b1f4d",
        "name": "Power Infusion",
        "shortName": "PI",
        "specId": "67a45712-192e-4916-ad57-d9a13124fea6"
      },
      "270c2610-9e02-4240-8eb2-4cb9c551fbe3": {
        "game_id": 73325,
        "icon_name": "priest_spell_leapoffaith_a",
        "id": "270c2610-9e02-4240-8eb2-4cb9c551fbe3",
        "name": "Leap of Faith",
        "shortName": "Leap",
        "specId": "d122a0b5-d857-4bc5-a456-c7250f8f6690"
      },
      "29d23e3f-53ed-4fa9-a788-39af5ac8cc21": {
        "game_id": 374227,
        "icon_name": "ability_evoker_hoverblack",
        "id": "29d23e3f-53ed-4fa9-a788-39af5ac8cc21",
        "name": "Zephyr",
        "shortName": "Zeph",
        "specId": "e6b1de69-ce2c-467c-ae7a-e1613ba23fb9"
      },
      "2b36a255-0d1f-4edb-ac7d-2f9cca13bfa3": {
        "game_id": 383269,
        "icon_name": "ability_maldraxxus_deathknight",
        "id": "2b36a255-0d1f-4edb-ac7d-2f9cca13bfa3",
        "link_suffix": "",
        "name": "Abomination Limb",
        "shortName": "Abom",
        "specId": "34735ecf-bf9e-4225-bb6e-ee617b024b70"
      },
      "3238af4a-e6bf-44a7-befe-0b3bb7a3d95d": {
        "game_id": 1022,
        "icon_name": "spell_holy_sealofprotection",
        "id": "3238af4a-e6bf-44a7-befe-0b3bb7a3d95d",
        "name": "Blessing of Protection",
        "shortName": "BoP",
        "specId": "8fceebcc-a93b-4692-81ea-331b2e59d43d"
      },
      "32687d7b-f4b4-45a5-a1d0-d64037b764e3": {
        "game_id": 374383,
        "icon_name": "spell_deathknight_antimagiczone",
        "id": "32687d7b-f4b4-45a5-a1d0-d64037b764e3",
        "link_suffix": "",
        "name": "Assimilation",
        "shortName": "Assi",
        "specId": "b72fb4f9-413a-4222-8569-b3cb8e5e67f2"
      },
      "36b1b8cd-86d9-43fd-92b7-ac5b1198cd07": {
        "game_id": 383269,
        "icon_name": "ability_maldraxxus_deathknight",
        "id": "36b1b8cd-86d9-43fd-92b7-ac5b1198cd07",
        "link_suffix": "",
        "name": "Abomination Limb",
        "shortName": "Abom",
        "specId": "1b478900-c50e-49f6-b9b1-d2fedfb10c2b"
      },
      "37a85b35-ee30-4f8a-aad5-679ba20ee2eb": {
        "game_id": 102793,
        "icon_name": "spell_druid_ursolsvortex",
        "id": "37a85b35-ee30-4f8a-aad5-679ba20ee2eb",
        "link_suffix": "",
        "name": "Ursol's Vortex",
        "shortName": "Vor",
        "specId": "be905ae2-ec32-49bf-bc82-ef1cbf83ce9f"
      },
      "37b9b1a4-c4e5-4290-be71-3eeab3bcf617": {
        "game_id": 108285,
        "icon_name": "ability_shaman_multitotemactivation",
        "id": "37b9b1a4-c4e5-4290-be71-3eeab3bcf617",
        "link_suffix": "",
        "name": "Totemic Recall",
        "shortName": "Recall",
        "specId": "1df0b300-a31e-4ebc-be57-a909f82bab4b"
      },
      "39bd329d-50e1-4e76-976c-360dedc08150": {
        "game_id": 114154,
        "icon_name": "spell_holy_holyguidance",
        "id": "39bd329d-50e1-4e76-976c-360dedc08150",
        "name": "Unbreakable Spirit",
        "shortName": "Unbr",
        "specId": "8fceebcc-a93b-4692-81ea-331b2e59d43d"
      },
      "3c45d7a2-9e52-4017-9f18-3014ffe0e430": {
        "game_id": 33891,
        "icon_name": "ability_druid_improvedtreeform",
        "id": "3c45d7a2-9e52-4017-9f18-3014ffe0e430",
        "name": "Incarnation: Tree of Life",
        "shortName": "Tree",
        "specId": "72947601-4270-4e1e-b917-25aacaa6d3e0"
      },
      "40039152-7e24-4b87-9693-459badf45081": {
        "game_id": 414660,
        "icon_name": "ability_racial_magicalresistance",
        "id": "40039152-7e24-4b87-9693-459badf45081",
        "name": "Mass Barrier",
        "shortName": "Barrier",
        "specId": "ab48ab5c-dfb9-4ce9-9557-8d0ce5129df2"
      },
      "446f9fbe-49ec-44ae-b856-c8631d8ef5b8": {
        "game_id": 192077,
        "icon_name": "ability_shaman_windwalktotem",
        "id": "446f9fbe-49ec-44ae-b856-c8631d8ef5b8",
        "name": "Wind Rush Totem",
        "shortName": "WRT",
        "specId": "51daa0f0-df16-4983-ae44-e11b5f9b3edb"
      },
      "45b5c689-fc1e-40a1-bf50-e41365e7456c": {
        "game_id": 102793,
        "icon_name": "spell_druid_ursolsvortex",
        "id": "45b5c689-fc1e-40a1-bf50-e41365e7456c",
        "link_suffix": "",
        "name": "Ursol's Vortex",
        "shortName": "Vor",
        "specId": "575905ae-cdc7-44c8-946c-861d50111b6d"
      },
      "467b7328-32ae-44e2-8532-3f958a7badb8": {
        "game_id": 108199,
        "icon_name": "ability_deathknight_aoedeathgrip",
        "id": "467b7328-32ae-44e2-8532-3f958a7badb8",
        "link_suffix": "",
        "name": "Gorefiend's Grasp",
        "shortName": "Grasp",
        "specId": "34735ecf-bf9e-4225-bb6e-ee617b024b70"
      },
      "4765648f-fc35-4305-bdce-e4353eec9c2c": {
        "game_id": 374968,
        "icon_name": "ability_evoker_timespiral",
        "id": "4765648f-fc35-4305-bdce-e4353eec9c2c",
        "name": "Time Spiral",
        "shortName": "Spiral",
        "specId": "48a205f0-5e24-4382-9e0b-3c06cfc1b873"
      },
      "48461dc1-c85b-470c-ba5a-269b701ebe18": {
        "game_id": 266921,
        "icon_name": "ability_hunter_aspectoftheviper",
        "id": "48461dc1-c85b-470c-ba5a-269b701ebe18",
        "name": "Born To Be Wild",
        "shortName": "BtbW",
        "specId": "2fed59fd-6bdc-4b4e-a7d6-70c70cf8a5aa"
      },
      "496f5f29-c065-4cfc-9cad-c7c31f51c188": {
        "game_id": 6262,
        "icon_name": "warlock_-healthstone",
        "id": "496f5f29-c065-4cfc-9cad-c7c31f51c188",
        "name": "Healthstone",
        "shortName": "HS",
        "specId": "ab48ab5c-dfb9-4ce9-9557-8d0ce5129df2"
      },
      "4d782bee-99f7-4568-9fad-84058719b8a3": {
        "game_id": 102793,
        "icon_name": "spell_druid_ursolsvortex",
        "id": "4d782bee-99f7-4568-9fad-84058719b8a3",
        "link_suffix": "",
        "name": "Ursol's Vortex",
        "shortName": "Vor",
        "specId": "6c233e8c-5bd4-4ece-9fb8-529a1e78759b"
      },
      "4f846cbc-f718-43ad-ab0a-812ca4467f23": {
        "game_id": 393371,
        "icon_name": "ability_druid_treeoflife",
        "id": "4f846cbc-f718-43ad-ab0a-812ca4467f23",
        "name": "Cenarius' Guidance",
        "shortName": "Guide",
        "specId": "72947601-4270-4e1e-b917-25aacaa6d3e0"
      },
      "5268ec1f-cde9-4148-ad41-bb67a35df24c": {
        "game_id": 322118,
        "icon_name": "ability_monk_dragonkick",
        "id": "5268ec1f-cde9-4148-ad41-bb67a35df24c",
        "link_suffix": "",
        "name": "Invoke Yu'lon, the Jade Serpent",
        "shortName": "Yulon",
        "specId": "da2dc773-9412-4b11-ab2b-7d06e200b9d3"
      },
      "534403c0-3c0d-45b3-9ef1-e3783fa41c08": {
        "game_id": 6940,
        "icon_name": "spell_holy_sealofsacrifice",
        "id": "534403c0-3c0d-45b3-9ef1-e3783fa41c08",
        "name": "Blessing of Sacrifice",
        "shortName": "Sac",
        "specId": "4ac0a1e4-3352-49e9-b455-faa83312526d"
      },
      "53f260ec-ac2b-4cb4-91b0-1b252665ee23": {
        "game_id": 381922,
        "icon_name": "ability_evoker_rewind",
        "id": "53f260ec-ac2b-4cb4-91b0-1b252665ee23",
        "name": "Temporal Artificer",
        "shortName": "Temp. Art",
        "specId": "48a205f0-5e24-4382-9e0b-3c06cfc1b873"
      },
      "5593c3e0-7e79-4351-9453-9b56a6a39293": {
        "game_id": 462791,
        "icon_name": "achievement_raidprimalist_windelemental",
        "id": "5593c3e0-7e79-4351-9453-9b56a6a39293",
        "link_suffix": "",
        "name": "Ascending Air",
        "shortName": "Air",
        "specId": "51daa0f0-df16-4983-ae44-e11b5f9b3edb"
      },
      "583dcc89-53be-49c8-a9ac-2a8da54f5ed7": {
        "game_id": 288826,
        "icon_name": "spell_druid_stamedingroar",
        "id": "583dcc89-53be-49c8-a9ac-2a8da54f5ed7",
        "name": "Improved Stampeding Roar",
        "shortName": "Imp. Roar",
        "specId": "575905ae-cdc7-44c8-946c-861d50111b6d"
      },
      "5859b929-053b-4ddb-b0d7-e14bf3f43d4b": {
        "game_id": 374383,
        "icon_name": "spell_deathknight_antimagiczone",
        "id": "5859b929-053b-4ddb-b0d7-e14bf3f43d4b",
        "link_suffix": "",
        "name": "Assimilation",
        "shortName": "Assi",
        "specId": "34735ecf-bf9e-4225-bb6e-ee617b024b70"
      },
      "59502386-a715-4059-9eba-bf5539df99ac": {
        "game_id": 32375,
        "icon_name": "spell_arcane_massdispel",
        "id": "59502386-a715-4059-9eba-bf5539df99ac",
        "name": "Mass Dispel",
        "shortName": "Mass",
        "specId": "67a45712-192e-4916-ad57-d9a13124fea6"
      },
      "5d8b76f1-d88a-4f9c-a3b5-27aae8a8077f": {
        "game_id": 199855,
        "icon_name": "achievement_boss_lanathel",
        "id": "5d8b76f1-d88a-4f9c-a3b5-27aae8a8077f",
        "name": "San'layn",
        "shortName": "San",
        "specId": "48c27d79-2cc2-4674-bfd0-9a471f6c7ced"
      },
      "5ea2d30f-6c4c-49b9-85d5-0d6995adc68c": {
        "game_id": 197073,
        "icon_name": "ability_druid_dreamstate",
        "id": "5ea2d30f-6c4c-49b9-85d5-0d6995adc68c",
        "name": "Inner Peace",
        "shortName": "IP",
        "specId": "72947601-4270-4e1e-b917-25aacaa6d3e0"
      },
      "6135360a-e47e-4124-bbda-82ca19adf51e": {
        "game_id": 390620,
        "icon_name": "ability_priest_savinggrace",
        "id": "6135360a-e47e-4124-bbda-82ca19adf51e",
        "name": "Move with Grace",
        "shortName": "Grace",
        "specId": "48c27d79-2cc2-4674-bfd0-9a471f6c7ced"
      },
      "6414c5fb-36ad-430f-ae2b-edaa0a58bf31": {
        "game_id": 192077,
        "icon_name": "ability_shaman_windwalktotem",
        "id": "6414c5fb-36ad-430f-ae2b-edaa0a58bf31",
        "name": "Wind Rush Totem",
        "shortName": "WRT",
        "specId": "1df0b300-a31e-4ebc-be57-a909f82bab4b"
      },
      "6798d5c7-eef8-4965-913b-3c60d97760f7": {
        "game_id": 206970,
        "icon_name": "spell_shadow_coneofsilence",
        "id": "6798d5c7-eef8-4965-913b-3c60d97760f7",
        "link_suffix": "",
        "name": "Tightening Grasp",
        "shortName": "Tight Grasp",
        "specId": "34735ecf-bf9e-4225-bb6e-ee617b024b70"
      },
      "6e25b87c-bc9a-446a-97f3-26c82d84bb2c": {
        "game_id": 421453,
        "icon_name": "ability_priest_ascendance",
        "id": "6e25b87c-bc9a-446a-97f3-26c82d84bb2c",
        "name": "Ultimate Penitence",
        "shortName": "Penti",
        "specId": "67a45712-192e-4916-ad57-d9a13124fea6"
      },
      "73034b1a-bd86-4d63-986d-00767150da9d": {
        "game_id": 370665,
        "icon_name": "ability_evoker_flywithme",
        "id": "73034b1a-bd86-4d63-986d-00767150da9d",
        "name": "Rescue",
        "shortName": "Resc",
        "specId": "e6b1de69-ce2c-467c-ae7a-e1613ba23fb9"
      },
      "7351775e-92b7-478f-a030-104aaf1d6adc": {
        "game_id": 29166,
        "icon_name": "spell_nature_lightning",
        "id": "7351775e-92b7-478f-a030-104aaf1d6adc",
        "name": "Innervate",
        "shortName": "Inn",
        "specId": "be905ae2-ec32-49bf-bc82-ef1cbf83ce9f"
      },
      "758b104b-e4db-4437-a728-06c0791981d6": {
        "game_id": 108285,
        "icon_name": "ability_shaman_multitotemactivation",
        "id": "758b104b-e4db-4437-a728-06c0791981d6",
        "link_suffix": "",
        "name": "Totemic Recall",
        "shortName": "Recall",
        "specId": "af2ca3dc-34c9-4632-98d2-6ea12a2a72f9"
      },
      "767e54f0-88e8-417f-9d8a-e487ca01fc6a": {
        "game_id": 383269,
        "icon_name": "ability_maldraxxus_deathknight",
        "id": "767e54f0-88e8-417f-9d8a-e487ca01fc6a",
        "link_suffix": "",
        "name": "Abomination Limb",
        "shortName": "Abom",
        "specId": "b72fb4f9-413a-4222-8569-b3cb8e5e67f2"
      },
      "785ffa5a-ad28-4cdc-8d55-d1035e67b2fc": {
        "game_id": 1022,
        "icon_name": "spell_holy_sealofprotection",
        "id": "785ffa5a-ad28-4cdc-8d55-d1035e67b2fc",
        "name": "Blessing of Protection",
        "shortName": "BoP",
        "specId": "4ac0a1e4-3352-49e9-b455-faa83312526d"
      },
      "7b46fd01-71ff-4529-b389-36572f789c27": {
        "game_id": 207399,
        "icon_name": "spell_nature_reincarnation",
        "id": "7b46fd01-71ff-4529-b389-36572f789c27",
        "name": "Ancestral Protection Totem",
        "shortName": "APT",
        "specId": "51daa0f0-df16-4983-ae44-e11b5f9b3edb"
      },
      "7ff235d6-9752-4d3f-a7b5-87d1df11b114": {
        "game_id": 202424,
        "icon_name": "ability_monk_domeofmist",
        "id": "7ff235d6-9752-4d3f-a7b5-87d1df11b114",
        "name": "Chrysalis",
        "shortName": "Chrys",
        "specId": "da2dc773-9412-4b11-ab2b-7d06e200b9d3"
      },
      "816a3a32-a4d2-4cfb-aad8-47c749c6222f": {
        "game_id": 216331,
        "icon_name": "ability_paladin_veneration",
        "id": "816a3a32-a4d2-4cfb-aad8-47c749c6222f",
        "name": "Avenging Crusader",
        "shortName": "Crusa",
        "specId": "e1af3b62-ddf5-4369-a528-dab8ab94d366"
      },
      "81b03fbd-2ac3-49d1-b0d7-0d8aaa97371c": {
        "game_id": 29166,
        "icon_name": "spell_nature_lightning",
        "id": "81b03fbd-2ac3-49d1-b0d7-0d8aaa97371c",
        "name": "Innervate",
        "shortName": "Inn",
        "specId": "6c233e8c-5bd4-4ece-9fb8-529a1e78759b"
      },
      "82799079-fa85-4f5e-879c-e65b685a5783": {
        "game_id": 29166,
        "icon_name": "spell_nature_lightning",
        "id": "82799079-fa85-4f5e-879c-e65b685a5783",
        "name": "Innervate",
        "shortName": "Inn",
        "specId": "575905ae-cdc7-44c8-946c-861d50111b6d"
      },
      "85050e0d-9137-4795-a826-d43e83b648bd": {
        "game_id": 414660,
        "icon_name": "ability_racial_magicalresistance",
        "id": "85050e0d-9137-4795-a826-d43e83b648bd",
        "name": "Mass Barrier",
        "shortName": "Barrier",
        "specId": "7f8d7fab-f5cc-4d47-9212-565bab25aeed"
      },
      "88aed695-3e44-4edc-9399-a9f0017c4acc": {
        "game_id": 108281,
        "icon_name": "ability_shaman_ancestralguidance",
        "id": "88aed695-3e44-4edc-9399-a9f0017c4acc",
        "name": "Ancestral Guidance",
        "shortName": "Guide",
        "specId": "1df0b300-a31e-4ebc-be57-a909f82bab4b"
      },
      "8a23386b-bec3-4c9c-8b91-6f0978cbd9e8": {
        "game_id": 32375,
        "icon_name": "spell_arcane_massdispel",
        "id": "8a23386b-bec3-4c9c-8b91-6f0978cbd9e8",
        "name": "Mass Dispel",
        "shortName": "Mass",
        "specId": "d122a0b5-d857-4bc5-a456-c7250f8f6690"
      },
      "8a529137-da4a-4974-96e5-7beb6bb028d6": {
        "game_id": 462791,
        "icon_name": "achievement_raidprimalist_windelemental",
        "id": "8a529137-da4a-4974-96e5-7beb6bb028d6",
        "link_suffix": "",
        "name": "Ascending Air",
        "shortName": "Air",
        "specId": "af2ca3dc-34c9-4632-98d2-6ea12a2a72f9"
      },
      "8c99b3d5-62d2-4672-bbec-50eb0f3c8fc2": {
        "game_id": 196718,
        "icon_name": "ability_demonhunter_darkness",
        "id": "8c99b3d5-62d2-4672-bbec-50eb0f3c8fc2",
        "link_suffix": "",
        "name": "Darkness",
        "shortName": "Dark",
        "specId": "08853913-0c47-4ca1-aec0-e93206a6ee45"
      },
      "8e1ffa2c-8997-4646-b1d1-b2f6483955c7": {
        "game_id": 383011,
        "icon_name": "ability_shaman_multitotemactivation",
        "id": "8e1ffa2c-8997-4646-b1d1-b2f6483955c7",
        "link_suffix": "",
        "name": "Call of the Elements",
        "shortName": "CotE",
        "specId": "1df0b300-a31e-4ebc-be57-a909f82bab4b"
      },
      "909f1f5b-a757-443d-b336-cd86f48d1dfd": {
        "game_id": 116841,
        "icon_name": "ability_monk_tigerslust",
        "id": "909f1f5b-a757-443d-b336-cd86f48d1dfd",
        "name": "Tiger's Lust",
        "shortName": "Lust",
        "specId": "da2dc773-9412-4b11-ab2b-7d06e200b9d3"
      },
      "90c7b081-5aa9-413d-a638-42961d68a966": {
        "game_id": 124974,
        "icon_name": "achievement_zone_feralas",
        "id": "90c7b081-5aa9-413d-a638-42961d68a966",
        "name": "Nature's Vigil",
        "shortName": "Vigil",
        "specId": "6c233e8c-5bd4-4ece-9fb8-529a1e78759b"
      },
      "94332795-35fc-4c49-bba0-18c103bb408e": {
        "game_id": 373905,
        "icon_name": "ability_vehicle_shellshieldgenerator_green",
        "id": "94332795-35fc-4c49-bba0-18c103bb408e",
        "name": "Personal 2min",
        "shortName": "Pers",
        "specId": "ab48ab5c-dfb9-4ce9-9557-8d0ce5129df2"
      },
      "9a9316a3-8f95-4cb4-9587-8745777e125f": {
        "game_id": 374227,
        "icon_name": "ability_evoker_hoverblack",
        "id": "9a9316a3-8f95-4cb4-9587-8745777e125f",
        "name": "Zephyr",
        "shortName": "Zeph",
        "specId": "cbfc9a1d-a504-4c56-8887-681e57a87211"
      },
      "a04511c0-e7e5-4877-b694-d2dffa11a5b2": {
        "game_id": 288826,
        "icon_name": "spell_druid_stamedingroar",
        "id": "a04511c0-e7e5-4877-b694-d2dffa11a5b2",
        "name": "Improved Stampeding Roar",
        "shortName": "Imp. Roar",
        "specId": "6c233e8c-5bd4-4ece-9fb8-529a1e78759b"
      },
      "a17bab75-7676-4f19-99b2-d83ef3d0ba47": {
        "game_id": 344359,
        "icon_name": "ability_monk_dpsstance",
        "id": "a17bab75-7676-4f19-99b2-d83ef3d0ba47",
        "link_suffix": "?def=129821&rank=2",
        "name": "Ancient Arts (2/2)",
        "shortName": "Arts",
        "specId": "88f4a6b5-7766-41c3-b824-fbba531a2c8e"
      },
      "a22a383c-ff9b-48d4-b532-1d1941d71774": {
        "game_id": 389783,
        "icon_name": "sha_spell_warlock_demonsoul",
        "id": "a22a383c-ff9b-48d4-b532-1d1941d71774",
        "name": "Pitch Black",
        "shortName": "Pitch",
        "specId": "c95c2375-57fa-4ae8-9d55-c2e939b82247"
      },
      "a30e6676-997f-4a3a-bb78-d353d6ab618d": {
        "game_id": 374968,
        "icon_name": "ability_evoker_timespiral",
        "id": "a30e6676-997f-4a3a-bb78-d353d6ab618d",
        "name": "Time Spiral",
        "shortName": "Spiral",
        "specId": "e6b1de69-ce2c-467c-ae7a-e1613ba23fb9"
      },
      "a5d22dfd-d455-47b6-9c74-9e6820822273": {
        "game_id": 266921,
        "icon_name": "ability_hunter_aspectoftheviper",
        "id": "a5d22dfd-d455-47b6-9c74-9e6820822273",
        "name": "Born To Be Wild",
        "shortName": "BtbW",
        "specId": "0c9d68bc-e126-4a07-817a-72c37094e005"
      },
      "a9b0335f-6b6c-4acd-8ebb-e00ff27061f3": {
        "game_id": 32375,
        "icon_name": "spell_arcane_massdispel",
        "id": "a9b0335f-6b6c-4acd-8ebb-e00ff27061f3",
        "name": "Mass Dispel",
        "shortName": "Mass",
        "specId": "48c27d79-2cc2-4674-bfd0-9a471f6c7ced"
      },
      "aa664140-7871-414a-ac39-5b19c0f56efc": {
        "game_id": 406732,
        "icon_name": "ability_evoker_stretchtime",
        "id": "aa664140-7871-414a-ac39-5b19c0f56efc",
        "name": "Spatial Paradox",
        "shortName": "Para",
        "specId": "e6b1de69-ce2c-467c-ae7a-e1613ba23fb9"
      },
      "ab58d1d9-db4d-4e7a-a014-86eaa08c1611": {
        "game_id": 359816,
        "icon_name": "ability_evoker_dreamflight",
        "id": "ab58d1d9-db4d-4e7a-a014-86eaa08c1611",
        "name": "Dream Flight",
        "shortName": "Dream",
        "specId": "48a205f0-5e24-4382-9e0b-3c06cfc1b873"
      },
      "acd54740-8f4f-4ef4-bf1a-7fc26d12b74b": {
        "game_id": 378425,
        "icon_name": "spell_holy_greaterblessingofsalvation",
        "id": "acd54740-8f4f-4ef4-bf1a-7fc26d12b74b",
        "link_suffix": "?def=107474&rank=1",
        "name": "Uther's Counsel (1/2)",
        "shortName": "Counsel",
        "specId": "8fceebcc-a93b-4692-81ea-331b2e59d43d"
      },
      "adb2c731-a09c-4c5a-a5cb-787fe6c5d768": {
        "game_id": 462791,
        "icon_name": "achievement_raidprimalist_windelemental",
        "id": "adb2c731-a09c-4c5a-a5cb-787fe6c5d768",
        "link_suffix": "",
        "name": "Ascending Air",
        "shortName": "Air",
        "specId": "1df0b300-a31e-4ebc-be57-a909f82bab4b"
      },
      "ae467e33-fb17-47ab-8fc2-d548b0f3f715": {
        "game_id": 404015,
        "icon_name": "ability_shaman_healingtide",
        "id": "ae467e33-fb17-47ab-8fc2-d548b0f3f715",
        "link_suffix": "",
        "name": "Current Control",
        "shortName": "CC",
        "specId": "51daa0f0-df16-4983-ae44-e11b5f9b3edb"
      },
      "b13f131b-222d-481c-93cb-fe4ac8e4ab9e": {
        "game_id": 370511,
        "icon_name": "inv_potion_49",
        "id": "b13f131b-222d-481c-93cb-fe4ac8e4ab9e",
        "name": "HP Pot",
        "shortName": "Pot",
        "specId": "ab48ab5c-dfb9-4ce9-9557-8d0ce5129df2"
      },
      "b2448fed-b273-4d91-897b-749bd8c26c12": {
        "game_id": 108281,
        "icon_name": "ability_shaman_ancestralguidance",
        "id": "b2448fed-b273-4d91-897b-749bd8c26c12",
        "name": "Ancestral Guidance",
        "shortName": "Guide",
        "specId": "af2ca3dc-34c9-4632-98d2-6ea12a2a72f9"
      },
      "b3ec93a1-6250-452a-ab54-e85e52924163": {
        "game_id": 102793,
        "icon_name": "spell_druid_ursolsvortex",
        "id": "b3ec93a1-6250-452a-ab54-e85e52924163",
        "link_suffix": "",
        "name": "Ursol's Vortex",
        "shortName": "Vor",
        "specId": "72947601-4270-4e1e-b917-25aacaa6d3e0"
      },
      "b79c8b55-8181-4eba-a8f3-d5da08cb994f": {
        "game_id": 344359,
        "icon_name": "ability_monk_dpsstance",
        "id": "b79c8b55-8181-4eba-a8f3-d5da08cb994f",
        "link_suffix": "?def=129821&rank=1",
        "name": "Ancient Arts (1/2)",
        "shortName": "Arts",
        "specId": "88f4a6b5-7766-41c3-b824-fbba531a2c8e"
      },
      "ba35bc19-6a14-4fe9-99a9-5f86a1d2ba69": {
        "game_id": 374968,
        "icon_name": "ability_evoker_timespiral",
        "id": "ba35bc19-6a14-4fe9-99a9-5f86a1d2ba69",
        "name": "Time Spiral",
        "shortName": "Spiral",
        "specId": "cbfc9a1d-a504-4c56-8887-681e57a87211"
      },
      "bb6eed55-913d-4289-b32a-6affe9882b83": {
        "game_id": 384909,
        "icon_name": "spell_holy_sealofprotection",
        "id": "bb6eed55-913d-4289-b32a-6affe9882b83",
        "name": "Improved Blessing of Protection",
        "shortName": "Imp Blessing",
        "specId": "4ac0a1e4-3352-49e9-b455-faa83312526d"
      },
      "bb927fdc-86d0-4d3c-868b-962396fb9b96": {
        "game_id": 379391,
        "icon_name": "spell_holy_pureofheart",
        "id": "bb927fdc-86d0-4d3c-868b-962396fb9b96",
        "name": "Quickened Invocation",
        "shortName": "Quickened Invocation",
        "specId": "e1af3b62-ddf5-4369-a528-dab8ab94d366"
      },
      "bbd1c3c3-96df-45f1-8c59-dea4fee0d9ca": {
        "game_id": 196718,
        "icon_name": "ability_demonhunter_darkness",
        "id": "bbd1c3c3-96df-45f1-8c59-dea4fee0d9ca",
        "link_suffix": "",
        "name": "Darkness",
        "shortName": "Dark",
        "specId": "c95c2375-57fa-4ae8-9d55-c2e939b82247"
      },
      "c2b8f54e-bc64-4f3f-bc20-342458ce8b34": {
        "game_id": 123040,
        "icon_name": "spell_shadow_soulleech_3",
        "id": "c2b8f54e-bc64-4f3f-bc20-342458ce8b34",
        "name": "Mindbender",
        "shortName": "Bender",
        "specId": "67a45712-192e-4916-ad57-d9a13124fea6"
      },
      "c32b2053-7d2d-4c02-a7cc-6325e09b4b68": {
        "game_id": 390620,
        "icon_name": "ability_priest_savinggrace",
        "id": "c32b2053-7d2d-4c02-a7cc-6325e09b4b68",
        "name": "Move with Grace",
        "shortName": "Grace",
        "specId": "67a45712-192e-4916-ad57-d9a13124fea6"
      },
      "c3e6af3d-81c1-440e-8f07-5c058b6500e9": {
        "game_id": 384909,
        "icon_name": "spell_holy_sealofprotection",
        "id": "c3e6af3d-81c1-440e-8f07-5c058b6500e9",
        "name": "Improved Blessing of Protection",
        "shortName": "Imp Blessing",
        "specId": "8fceebcc-a93b-4692-81ea-331b2e59d43d"
      },
      "c473579c-60b9-4a98-bd6e-75073994f1f3": {
        "game_id": 114052,
        "icon_name": "spell_fire_elementaldevastation",
        "id": "c473579c-60b9-4a98-bd6e-75073994f1f3",
        "name": "Ascendance",
        "shortName": "Asc",
        "specId": "51daa0f0-df16-4983-ae44-e11b5f9b3edb"
      },
      "c63562ef-5188-4a55-aefe-6ae707d4fc9d": {
        "game_id": 288826,
        "icon_name": "spell_druid_stamedingroar",
        "id": "c63562ef-5188-4a55-aefe-6ae707d4fc9d",
        "name": "Improved Stampeding Roar",
        "shortName": "Imp. Roar",
        "specId": "be905ae2-ec32-49bf-bc82-ef1cbf83ce9f"
      },
      "c895b503-d882-4b28-857e-82dd60f2767d": {
        "game_id": 16191,
        "icon_name": "ability_shaman_manatidetotem",
        "id": "c895b503-d882-4b28-857e-82dd60f2767d",
        "name": "Mana Tide Totem",
        "shortName": "MTT",
        "specId": "51daa0f0-df16-4983-ae44-e11b5f9b3edb"
      },
      "c98d366c-eae5-42a5-92e8-1288aa88eb0c": {
        "game_id": 288826,
        "icon_name": "spell_druid_stamedingroar",
        "id": "c98d366c-eae5-42a5-92e8-1288aa88eb0c",
        "name": "Improved Stampeding Roar",
        "shortName": "Imp. Roar",
        "specId": "72947601-4270-4e1e-b917-25aacaa6d3e0"
      },
      "ca124356-8a91-4702-8f65-d5f36efb7f74": {
        "game_id": 15286,
        "icon_name": "spell_shadow_unsummonbuilding",
        "id": "ca124356-8a91-4702-8f65-d5f36efb7f74",
        "link_suffix": "",
        "name": "Vampiric Embrace",
        "shortName": "Vamp",
        "specId": "48c27d79-2cc2-4674-bfd0-9a471f6c7ced"
      },
      "cbf60eb9-cf97-4773-9ac7-0d7604dedaf0": {
        "game_id": 406732,
        "icon_name": "ability_evoker_stretchtime",
        "id": "cbf60eb9-cf97-4773-9ac7-0d7604dedaf0",
        "name": "Spatial Paradox",
        "shortName": "Para",
        "specId": "48a205f0-5e24-4382-9e0b-3c06cfc1b873"
      },
      "cc962c25-6a3b-4af0-b286-da67b821f3e7": {
        "game_id": 374383,
        "icon_name": "spell_deathknight_antimagiczone",
        "id": "cc962c25-6a3b-4af0-b286-da67b821f3e7",
        "link_suffix": "",
        "name": "Assimilation",
        "shortName": "Assi",
        "specId": "1b478900-c50e-49f6-b9b1-d2fedfb10c2b"
      },
      "cff1e89d-61b7-475f-8be5-f1b8e0e9badf": {
        "game_id": 406732,
        "icon_name": "ability_evoker_stretchtime",
        "id": "cff1e89d-61b7-475f-8be5-f1b8e0e9badf",
        "name": "Spatial Paradox",
        "shortName": "Para",
        "specId": "cbfc9a1d-a504-4c56-8887-681e57a87211"
      },
      "d1218a0b-f1c3-4c76-a222-b93cb9a5fd04": {
        "game_id": 381867,
        "icon_name": "spell_nature_agitatingtotem",
        "id": "d1218a0b-f1c3-4c76-a222-b93cb9a5fd04",
        "link_suffix": "",
        "name": "Totemic Surge",
        "shortName": "TS",
        "specId": "51daa0f0-df16-4983-ae44-e11b5f9b3edb"
      },
      "d3753af3-0a20-46d8-bd73-0702c8f1826f": {
        "game_id": 388212,
        "icon_name": "inv_pet_jadeserpentpet",
        "id": "d3753af3-0a20-46d8-bd73-0702c8f1826f",
        "name": "Gift of the Celestials",
        "shortName": "Gift",
        "specId": "da2dc773-9412-4b11-ab2b-7d06e200b9d3"
      },
      "d48a7d3f-16f6-4e44-bed2-fee66d8ea35a": {
        "game_id": 382552,
        "icon_name": "spell_druid_ironbark",
        "id": "d48a7d3f-16f6-4e44-bed2-fee66d8ea35a",
        "name": "Improved Ironbark",
        "shortName": "Imp. IB",
        "specId": "72947601-4270-4e1e-b917-25aacaa6d3e0"
      },
      "d5a857c6-ac57-4c82-b898-c998614e61bd": {
        "game_id": 114154,
        "icon_name": "spell_holy_holyguidance",
        "id": "d5a857c6-ac57-4c82-b898-c998614e61bd",
        "name": "Unbreakable Spirit",
        "shortName": "Unbr",
        "specId": "e1af3b62-ddf5-4369-a528-dab8ab94d366"
      },
      "d740f1d1-23b0-4047-8ba1-d81aad23336b": {
        "game_id": 6940,
        "icon_name": "spell_holy_sealofsacrifice",
        "id": "d740f1d1-23b0-4047-8ba1-d81aad23336b",
        "name": "Blessing of Sacrifice",
        "shortName": "Sac",
        "specId": "8fceebcc-a93b-4692-81ea-331b2e59d43d"
      },
      "d83b8700-8bfa-4601-aa8a-9afc6bf9e019": {
        "game_id": 344359,
        "icon_name": "ability_monk_dpsstance",
        "id": "d83b8700-8bfa-4601-aa8a-9afc6bf9e019",
        "link_suffix": "?def=129821&rank=1",
        "name": "Ancient Arts (1/2)",
        "shortName": "Arts",
        "specId": "18dad85c-ac2c-4aac-b0f8-e0fc4b8633e6"
      },
      "d8d6839a-17e6-4932-b0f1-0219b61a03f9": {
        "game_id": 462440,
        "icon_name": "spell_shaman_astralshift",
        "id": "d8d6839a-17e6-4932-b0f1-0219b61a03f9",
        "link_suffix": "",
        "name": "First Ascendant",
        "shortName": "FA",
        "specId": "51daa0f0-df16-4983-ae44-e11b5f9b3edb"
      },
      "d8f9ecd6-716b-4389-9d7e-99a1b43a6af9": {
        "game_id": 384820,
        "icon_name": "spell_holy_sealofsacrifice",
        "id": "d8f9ecd6-716b-4389-9d7e-99a1b43a6af9",
        "name": "Sacrifice of the Just",
        "shortName": "Just",
        "specId": "e1af3b62-ddf5-4369-a528-dab8ab94d366"
      },
      "db645c3d-704e-43b1-97ef-c6c0f2119c8d": {
        "game_id": 370665,
        "icon_name": "ability_evoker_flywithme",
        "id": "db645c3d-704e-43b1-97ef-c6c0f2119c8d",
        "name": "Rescue",
        "shortName": "Resc",
        "specId": "cbfc9a1d-a504-4c56-8887-681e57a87211"
      },
      "dc690ae9-da03-4789-ba73-6a34a9c9f4b0": {
        "game_id": 116841,
        "icon_name": "ability_monk_tigerslust",
        "id": "dc690ae9-da03-4789-ba73-6a34a9c9f4b0",
        "name": "Tiger's Lust",
        "shortName": "Lust",
        "specId": "88f4a6b5-7766-41c3-b824-fbba531a2c8e"
      },
      "dcc4d8cc-cd6e-4b5d-8ce1-d22b0695212a": {
        "game_id": 265202,
        "icon_name": "ability_priest_archangel",
        "id": "dcc4d8cc-cd6e-4b5d-8ce1-d22b0695212a",
        "name": "Holy Word: Salvation",
        "shortName": "Salv",
        "specId": "d122a0b5-d857-4bc5-a456-c7250f8f6690"
      },
      "dfd7b903-eab9-4010-ab5d-2e09abd07fd6": {
        "game_id": 381867,
        "icon_name": "spell_nature_agitatingtotem",
        "id": "dfd7b903-eab9-4010-ab5d-2e09abd07fd6",
        "link_suffix": "",
        "name": "Totemic Surge",
        "shortName": "TS",
        "specId": "af2ca3dc-34c9-4632-98d2-6ea12a2a72f9"
      },
      "e49ee804-2e24-47ea-9004-5af8b327b73f": {
        "game_id": 381867,
        "icon_name": "spell_nature_agitatingtotem",
        "id": "e49ee804-2e24-47ea-9004-5af8b327b73f",
        "link_suffix": "",
        "name": "Totemic Surge",
        "shortName": "TS",
        "specId": "1df0b300-a31e-4ebc-be57-a909f82bab4b"
      },
      "e4ef9154-7c60-4f82-b7f4-aee7e072bea1": {
        "game_id": 414660,
        "icon_name": "ability_racial_magicalresistance",
        "id": "e4ef9154-7c60-4f82-b7f4-aee7e072bea1",
        "name": "Mass Barrier",
        "shortName": "Barrier",
        "specId": "a022f6ed-2b4e-4ddf-a7e9-7fb746f5adc2"
      },
      "e5ef6ddf-9621-484c-86ab-e02943b2145e": {
        "game_id": 392911,
        "icon_name": "spell_holy_fanaticism",
        "id": "e5ef6ddf-9621-484c-86ab-e02943b2145e",
        "name": "Unwavering Spirit",
        "shortName": "Spirit",
        "specId": "e1af3b62-ddf5-4369-a528-dab8ab94d366"
      },
      "e6d6e422-df70-4eca-a4f7-be3c357887a2": {
        "game_id": 378425,
        "icon_name": "spell_holy_greaterblessingofsalvation",
        "id": "e6d6e422-df70-4eca-a4f7-be3c357887a2",
        "link_suffix": "?def=107474&rank=2",
        "name": "Uther's Counsel (2/2)",
        "shortName": "Counsel",
        "specId": "8fceebcc-a93b-4692-81ea-331b2e59d43d"
      },
      "e85a95e3-89cf-4a0a-8ecd-498d67ce906d": {
        "game_id": 73325,
        "icon_name": "priest_spell_leapoffaith_a",
        "id": "e85a95e3-89cf-4a0a-8ecd-498d67ce906d",
        "name": "Leap of Faith",
        "shortName": "Leap",
        "specId": "48c27d79-2cc2-4674-bfd0-9a471f6c7ced"
      },
      "e9389c2c-4ab3-49eb-93db-030b2a7f4f38": {
        "game_id": 266921,
        "icon_name": "ability_hunter_aspectoftheviper",
        "id": "e9389c2c-4ab3-49eb-93db-030b2a7f4f38",
        "name": "Born To Be Wild",
        "shortName": "BtbW",
        "specId": "34b5a797-05ef-4431-91a0-64cc76a97624"
      },
      "e9ed1039-2542-45a5-9a7e-0da17313acfa": {
        "game_id": 370960,
        "icon_name": "ability_evoker_green_01",
        "id": "e9ed1039-2542-45a5-9a7e-0da17313acfa",
        "name": "Emerald Communion",
        "shortName": "Com",
        "specId": "48a205f0-5e24-4382-9e0b-3c06cfc1b873"
      },
      "ec19073f-a8e0-4d9f-b011-66a417942590": {
        "game_id": 10060,
        "icon_name": "spell_holy_powerinfusion",
        "id": "ec19073f-a8e0-4d9f-b011-66a417942590",
        "name": "Power Infusion",
        "shortName": "PI",
        "specId": "d122a0b5-d857-4bc5-a456-c7250f8f6690"
      },
      "ecc35489-c4e9-4f68-8901-74620e18cdc4": {
        "game_id": 376210,
        "icon_name": "ability_bossmagistrix_timewarp2",
        "id": "ecc35489-c4e9-4f68-8901-74620e18cdc4",
        "name": "Erasure",
        "shortName": "Erasure",
        "specId": "48a205f0-5e24-4382-9e0b-3c06cfc1b873"
      },
      "f9902ec9-b2b7-4b8a-95d7-f9a11d14eb73": {
        "game_id": 384820,
        "icon_name": "spell_holy_sealofsacrifice",
        "id": "f9902ec9-b2b7-4b8a-95d7-f9a11d14eb73",
        "name": "Sacrifice of the Just",
        "shortName": "Just",
        "specId": "4ac0a1e4-3352-49e9-b455-faa83312526d"
      },
      "fa1c4c3c-2365-4bc9-9b94-80f64b91ff0c": {
        "game_id": 114154,
        "icon_name": "spell_holy_holyguidance",
        "id": "fa1c4c3c-2365-4bc9-9b94-80f64b91ff0c",
        "name": "Unbreakable Spirit",
        "shortName": "Unbr",
        "specId": "4ac0a1e4-3352-49e9-b455-faa83312526d"
      },
      "faa69883-c426-46d8-b4c5-78959be4f168": {
        "game_id": 384909,
        "icon_name": "spell_holy_sealofprotection",
        "id": "faa69883-c426-46d8-b4c5-78959be4f168",
        "name": "Improved Blessing of Protection",
        "shortName": "Imp Blessing",
        "specId": "e1af3b62-ddf5-4369-a528-dab8ab94d366"
      },
      "fae8f28c-27b6-4cf9-8ed3-cb1bb3701924": {
        "game_id": 370665,
        "icon_name": "ability_evoker_flywithme",
        "id": "fae8f28c-27b6-4cf9-8ed3-cb1bb3701924",
        "name": "Rescue",
        "shortName": "Resc",
        "specId": "48a205f0-5e24-4382-9e0b-3c06cfc1b873"
      },
      "fdf0f7fc-8feb-462c-a253-2711e3406cce": {
        "game_id": 344359,
        "icon_name": "ability_monk_dpsstance",
        "id": "fdf0f7fc-8feb-462c-a253-2711e3406cce",
        "link_suffix": "?def=129821&rank=2",
        "name": "Ancient Arts (2/2)",
        "shortName": "Arts",
        "specId": "da2dc773-9412-4b11-ab2b-7d06e200b9d3"
      },
      "fe615593-20ff-4088-a323-e7087544216e": {
        "game_id": 389783,
        "icon_name": "sha_spell_warlock_demonsoul",
        "id": "fe615593-20ff-4088-a323-e7087544216e",
        "name": "Pitch Black",
        "shortName": "Pitch",
        "specId": "08853913-0c47-4ca1-aec0-e93206a6ee45"
      }
    }
  }`)
